import React,
{
    useEffect,
    useMemo,
    useRef,
    useState
}
from 'react';
import masterVolume from './masterVolume';
import
{
    createPreloadedAudio
}
from './audioPreload';

const FRNC_ACCESS_ENDPOINT = '/api/frnc-access';
const FRNC_DOC_URL = '/Downloads/PUCPlaybook.html';
const FRNC_STEAM_CLASS_ICONS = {
    '76561198093224321': 'scout',
    '76561199674889547': 'soldier',
    '76561198200751498': 'pyro',
    '76561198285049108': 'demo',
    '76561198313360974': 'heavy',
    '76561199165058254': 'engie',
    '76561198346251523': 'medic',
    '76561198103338374': 'sniper',
    '76561198103080990': 'spy',
    
};
const FRNC_AUDIO_CONFIG_URL = '/frncAudio.json';
const FRNC_EMOJI_CONFIG_URL = '/frncEmoji.json';
const FRNC_PLAYLIST_CONFIG_URL = '/frncPlaylist.json';
const FRNC_DOC_REFRESH_MS = 10000;
const FRNC_DOC_LOAD_FALLBACK_PROGRESS = {
    preparing: 4,
    waiting: 12,
    downloading: 36,
    parsing: 94,
    ready: 100,
};
const FRNC_PASS_ENTRY_BPM = 230;
const FRNC_PASS_ENTRY_BEAT_MS = (60 / FRNC_PASS_ENTRY_BPM) * 1000;
const FRNC_TITLE_SEQUENCE_MS = 1000;
const FRNC_TITLE_SEQUENCE_SETTLE_START_MS = Math.round(FRNC_TITLE_SEQUENCE_MS * 0.92);
const FRNC_DOC_UI_INTRO_MS = 900;
const FRNC_PASSWORD_STAGE_AUDIO_KEYS = ['accessGranted', 'accessDenied', 'passGoesDown'];
const FRNC_CONTENT_STAGE_AUDIO_KEYS = ['titleTransition', 'titleTransitionFixed', 'docUiAppears', 'docButtonClick'];
const FRNC_PRELOADED_UI_AUDIO_KEYS = Array.from(new Set([
    ...FRNC_PASSWORD_STAGE_AUDIO_KEYS,
    ...FRNC_CONTENT_STAGE_AUDIO_KEYS,
]));
const FRNC_SEQUENCE_ENTRY = 'entry';
const FRNC_SEQUENCE_REFRESH = 'refresh';
const FRNC_SEQUENCE_EXIT = 'exit';
const FRNC_PASS_ENTRY_NO_BOUNCE_BEATS = new Set([8, 16]);
const FRNC_REFRESH_NO_BOUNCE_BEATS = new Set();
const FRNC_EXIT_NO_BOUNCE_BEATS = new Set();
const FRNC_PASS_ENTRY_TILT_DEG = 6;
const FRNC_PASS_ENTRY_TILT_RESET_BEAT = 15;
const FRNC_REFRESH_TILT_RESET_BEAT = 7;
const FRNC_EXIT_TILT_RESET_BEAT = 7;
const FRNC_PASS_ENTRY_SEQUENCE = [
{
    type: 'append',
    lineIndex: 0,
    value: 'P'
},
{
    type: 'append',
    lineIndex: 0,
    value: 'O'
},
{
    type: 'append',
    lineIndex: 0,
    value: 'S'
},
{
    type: 'append',
    lineIndex: 0,
    value: 'T '
},
{
    type: 'append',
    lineIndex: 0,
    value: 'Ü'
},
{
    type: 'append',
    lineIndex: 0,
    value: 'B'
},
{
    type: 'append',
    lineIndex: 0,
    value: 'ER'
},
{
    type: 'switch-line',
    lineIndex: 1
},
{
    type: 'append',
    lineIndex: 1,
    value: 'C'
},
{
    type: 'append',
    lineIndex: 1,
    value: 'LA'
},
{
    type: 'append',
    lineIndex: 1,
    value: 'RI'
},
{
    type: 'append',
    lineIndex: 1,
    value: 'TY '
},
{
    type: 'append',
    lineIndex: 1,
    value: 'PL'
},
{
    type: 'append',
    lineIndex: 1,
    value: 'AYB'
},
{
    type: 'append',
    lineIndex: 1,
    value: 'OOK'
},
{
    type: 'complete'
}, ];
const FRNC_REFRESH_ENTRY_SEQUENCE = [
{
    type: 'append',
    lineIndex: 0,
    value: 'POST'
},
{
    type: 'hold'
},
{
    type: 'append',
    lineIndex: 0,
    value: ' ÜBER'
},
{
    type: 'switch-line',
    lineIndex: 1
},
{
    type: 'append',
    lineIndex: 1,
    value: 'CLARITY'
},
{
    type: 'hold'
},
{
    type: 'append',
    lineIndex: 1,
    value: ' PLAYBOOK'
}, ];
const FRNC_EXIT_SEQUENCE = [
{
    type: 'set-lines',
    firstLine: 'POST ÜBER',
    secondLine: 'CLARITY PLAYBOOK',
    activeLine: 1
},
{
    type: 'hold'
},
{
    type: 'hold'
},
{
    type: 'hold'
},
{
    type: 'hold'
},
{
    type: 'hold'
},
{
    type: 'set-lines',
    firstLine: 'Bye!',
    secondLine: '',
    activeLine: 0
},
{
    type: 'hold'
}, ];
const FRNC_REFRESH_ENTRY_TOTAL_BEATS = 8;
const FRNC_EXIT_TOTAL_BEATS = 8;
const FRNC_EXIT_REDIRECT_DELAY_MS = 500;
const FRNC_EXIT_SPIN_DURATION_MS = Math.round((FRNC_EXIT_TILT_RESET_BEAT - 1) * FRNC_PASS_ENTRY_BEAT_MS);
const EMOJI_TOKEN_PATTERN = /:([a-zA-Z0-9_ -]+):/g;
const MAIN_FONT_STACK = "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
const FRNC_CONTENT_FONT_STACK = "Georgia, 'Times New Roman', serif";
const DEFAULT_AUDIO_CONFIG = {
    sounds:
    {
        accessDenied:
        {
            src: '/Audio/ButtonNoRedirect.wav',
            baseVolume: 1.0,
        },
        accessGranted:
        {
            src: '/Audio/FRNC/UI_PassAccessGranted.ogg',
            baseVolume: 1.0,
        },
        passGoesDown:
        {
            src: '/Audio/FRNC/UI_PassGoesDown.ogg',
            baseVolume: 1.0,
        },
        passEntryBeat:
        {
            src: '/Audio/FRNC/BumpPassEntry.ogg',
            baseVolume: 1.0,
        },
        refreshBeat:
        {
            src: '/Audio/FRNC/BumpRefresh.ogg',
            baseVolume: 1.0,
        },
        exitBeat:
        {
            src: '/Audio/FRNC/BumpRefreshUpdate.ogg',
            baseVolume: 1.0,
        },
        titleTransition:
        {
            src: '/Audio/FRNC/UI_DocTitleTransitions.ogg',
            baseVolume: 1.0,
        },
        titleTransitionFixed:
        {
            src: '/Audio/FRNC/UI_DocTitleTransitionsFixed.ogg',
            baseVolume: 1.0,
        },
        docUiAppears:
        {
            src: '/Audio/FRNC/UI_DocShitAppears.ogg',
            baseVolume: 1.0,
        },
        docButtonClick:
        {
            src: '/Audio/FRNC/UI_DocButtonClick.ogg',
            baseVolume: 1.0,
        },
    },
};
const DEFAULT_EMOJI_CONFIG = {
    globalScale: 1,
    emojis:
    {
        demo:
        {},
        engie:
        {},
        heavy:
        {},
        medic:
        {},
        pyro:
        {},
        scout:
        {},
        sniper:
        {},
        soldier:
        {},
        spy:
        {},
    },
};

const BLOCK_STYLES = {
    p:
    {
        margin: '0 0 1rem',
        lineHeight: 1.72
    },
    div:
    {
        margin: '0 0 0.85rem',
        lineHeight: 1.72
    },
    h1:
    {
        margin: '0 0 1rem',
        fontSize: '2rem',
        lineHeight: 1.16
    },
    h2:
    {
        margin: '0 0 0.95rem',
        fontSize: '1.65rem',
        lineHeight: 1.2
    },
    h3:
    {
        margin: '0 0 0.9rem',
        fontSize: '1.35rem',
        lineHeight: 1.24
    },
    h4:
    {
        margin: '0 0 0.8rem',
        fontSize: '1.15rem',
        lineHeight: 1.28
    },
    h5:
    {
        margin: '0 0 0.75rem',
        fontSize: '1rem',
        lineHeight: 1.3
    },
    h6:
    {
        margin: '0 0 0.7rem',
        fontSize: '0.92rem',
        lineHeight: 1.32,
        letterSpacing: '0.05em',
        textTransform: 'uppercase'
    },
    blockquote:
    {
        margin: '1rem 0',
        padding: '0.4rem 0 0.4rem 1rem',
        borderLeft: '2px solid rgba(255,255,255,0.28)',
        color: 'rgba(245,245,245,0.82)'
    },
    ul:
    {
        margin: '0 0 1rem 1.2rem',
        padding: 0
    },
    ol:
    {
        margin: '0 0 1rem 1.2rem',
        padding: 0
    },
    li:
    {
        margin: '0.2rem 0',
        lineHeight: 1.68
    },
    hr:
    {
        border: 0,
        borderTop: '1px solid rgba(255,255,255,0.12)',
        margin: '1.2rem 0'
    },
    pre:
    {
        margin: '1rem 0',
        padding: '1rem',
        background: 'rgba(255,255,255,0.06)',
        overflowX: 'auto',
        fontSize: '0.92rem',
        lineHeight: 1.6
    },
    code:
    {
        fontFamily: 'Consolas, Monaco, monospace',
        background: 'rgba(255,255,255,0.06)',
        padding: '0.08rem 0.28rem'
    },
    tableWrap:
    {
        margin: '1rem 0',
        overflowX: 'auto'
    },
    table:
    {
        width: '100%',
        borderCollapse: 'collapse',
        minWidth: 420
    },
    td:
    {
        border: '1px solid rgba(255,255,255,0.12)',
        padding: '0.55rem 0.7rem',
        verticalAlign: 'top'
    },
    th:
    {
        border: '1px solid rgba(255,255,255,0.12)',
        padding: '0.55rem 0.7rem',
        textAlign: 'left',
        background: 'rgba(255,255,255,0.05)'
    },
};

const VIDEO_FILE_PATTERN = /\.(mp4|webm|ogg|mov|m4v)(?:[?#].*)?$/i;
const SECTION_MARKER_PATTERN = /^##\s*(\d+)\.(\d+)\.(\d+)\.?\s*(.*)$/;

function cssPropertyToReact(property)
{
    if (!property) return '';
    if (property.startsWith('-webkit-'))
    {
        const webkitBody = property.slice(8).replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
        return `Webkit${webkitBody.charAt(0).toUpperCase()}${webkitBody.slice(1)}`;
    }

    return property.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
}

function parseCssDeclarations(input)
{
    const output = {};
    String(input || '')
        .split(';')
        .map((part) => part.trim())
        .filter(Boolean)
        .forEach((declaration) =>
        {
            const separatorIndex = declaration.indexOf(':');
            if (separatorIndex < 0) return;

            const property = cssPropertyToReact(declaration.slice(0, separatorIndex).trim());
            const value = declaration.slice(separatorIndex + 1).trim();
            if (!property || !value) return;
            output[property] = value;
        });

    return output;
}

function parseDocumentStyles(doc)
{
    const classStyles = {};
    const tagStyles = {};

    try
    {
        const styleText = Array.from(doc.querySelectorAll('style'))
            .map((node) => node.textContent || '')
            .join('\n');

        const rulePattern = /([^{}]+)\{([^{}]+)\}/g;
        let match = rulePattern.exec(styleText);
        while (match)
        {
            const selectors = match[1].split(',').map((part) => part.trim()).filter(Boolean);
            const declarations = parseCssDeclarations(match[2]);

            selectors.forEach((selector) =>
            {
                if (/^\.[A-Za-z0-9_-]+$/.test(selector))
                {
                    const className = selector.slice(1);
                    classStyles[className] = {
                        ...(classStyles[className] ||
                        {}),
                        ...declarations
                    };
                }
                else if (/^[A-Za-z][A-Za-z0-9-]*$/.test(selector))
                {
                    const tagName = selector.toLowerCase();
                    tagStyles[tagName] = {
                        ...(tagStyles[tagName] ||
                        {}),
                        ...declarations
                    };
                }
            });

            match = rulePattern.exec(styleText);
        }
    }
    catch (e)
    {}

    return {
        classStyles,
        tagStyles
    };
}

function toAbsoluteUrl(value)
{
    if (!value) return '';
    try
    {
        return new URL(value, window.location.href).toString();
    }
    catch (e)
    {
        return String(value);
    }
}

function toDocumentAssetUrl(value)
{
    if (!value) return '';

    try
    {
        const documentUrl = new URL(FRNC_DOC_URL, window.location.href);
        return new URL(value, documentUrl).toString();
    }
    catch (e)
    {
        return String(value);
    }
}

function getVideoDescriptor(url)
{
    const absoluteUrl = toAbsoluteUrl(url);
    if (!absoluteUrl) return null;

    if (VIDEO_FILE_PATTERN.test(absoluteUrl))
    {
        return {
            type: 'video',
            src: absoluteUrl
        };
    }

    try
    {
        const parsed = new URL(absoluteUrl);
        const host = parsed.hostname.replace(/^www\./, '').toLowerCase();

        if (host === 'youtu.be')
        {
            const id = parsed.pathname.split('/').filter(Boolean)[0];
            if (id) return {
                type: 'embed',
                src: `https://www.youtube.com/embed/${id}`
            };
        }

        if (host.endsWith('youtube.com'))
        {
            const id = parsed.searchParams.get('v');
            if (id) return {
                type: 'embed',
                src: `https://www.youtube.com/embed/${id}`
            };
            if (parsed.pathname.startsWith('/embed/')) return {
                type: 'embed',
                src: absoluteUrl
            };
        }

        if (host === 'vimeo.com')
        {
            const id = parsed.pathname.split('/').filter(Boolean)[0];
            if (id) return {
                type: 'embed',
                src: `https://player.vimeo.com/video/${id}`
            };
        }

        if (host === 'player.vimeo.com')
        {
            return {
                type: 'embed',
                src: absoluteUrl
            };
        }

        if (host === 'drive.google.com')
        {
            const fileMatch = parsed.pathname.match(/\/file\/d\/([^/]+)/i);
            const fileId = fileMatch ? fileMatch[1] : parsed.searchParams.get('id');
            if (fileId) return {
                type: 'embed',
                src: `https://drive.google.com/file/d/${fileId}/preview`
            };
        }
    }
    catch (e)
    {}

    return null;
}

function getVideoSourceFromElement(node)
{
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return null;

    const directSrc = node.getAttribute('src') || '';
    if (directSrc) return {
        type: 'video',
        src: toAbsoluteUrl(directSrc)
    };

    const sourceEl = node.querySelector('source[src]');
    if (!sourceEl) return null;

    return {
        type: 'video',
        src: toAbsoluteUrl(sourceEl.getAttribute('src') || '')
    };
}

function parseDocumentModel(html)
{
    if (!html) return {
        root: null,
        styles:
        {
            classStyles:
            {},
            tagStyles:
            {}
        }
    };

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const styles = parseDocumentStyles(doc);
    const root = doc.querySelector('#contents') ||
        doc.querySelector('.doc-content') ||
        doc.querySelector('.kix-page-content-wrapper') ||
        doc.querySelector('article') ||
        doc.querySelector('main') ||
        doc.body;

    if (!root) return {
        root: null,
        styles
    };

    const clone = root.cloneNode(true);
    try
    {
        stripGoogleDocComments(clone);
        clone.querySelectorAll('script, style, noscript, meta, link, title, header, footer, nav').forEach((node) => node.remove());
    }
    catch (e)
    {}

    return {
        root: clone,
        styles
    };
}

function getMediaDescriptorKey(media)
{
    if (!media || !media.type || !media.src) return '';

    const normalizedSrc = (media.type === 'image' ? toDocumentAssetUrl(media.src) : toAbsoluteUrl(media.src)) || String(media.src || '').trim();
    if (!normalizedSrc) return '';

    return `${media.type}:${normalizedSrc}`;
}

function collectDocumentMediaKeys(root)
{
    const mediaKeys = new Set();
    if (!root) return mediaKeys;

    try
    {
        root.querySelectorAll('img[src]').forEach((node) =>
        {
            const key = getMediaDescriptorKey(
            {
                type: 'image',
                src: node.getAttribute('src') || ''
            });
            if (key) mediaKeys.add(key);
        });

        root.querySelectorAll('video').forEach((node) =>
        {
            const descriptor = getVideoSourceFromElement(node);
            const key = getMediaDescriptorKey(descriptor);
            if (key) mediaKeys.add(key);
        });

        root.querySelectorAll('iframe[src]').forEach((node) =>
        {
            const key = getMediaDescriptorKey(
            {
                type: 'embed',
                src: node.getAttribute('src') || ''
            });
            if (key) mediaKeys.add(key);
        });

        root.querySelectorAll('a[href]').forEach((node) =>
        {
            const descriptor = getVideoDescriptor(node.getAttribute('href') || '');
            const key = getMediaDescriptorKey(descriptor);
            if (key) mediaKeys.add(key);
        });
    }
    catch (e)
    {}

    return mediaKeys;
}

function parseSectionMarker(node)
{
    if (!node) return null;

    const rawText = String(node.textContent || '').trim();
    if (!rawText) return null;

    const match = rawText.match(SECTION_MARKER_PATTERN);
    if (!match) return null;

    const major = Number(match[1]);
    const minor = Number(match[2]);
    const patch = Number(match[3]);
    const rawTail = String(match[4] || '');
    const inlineTitleEndIndex = rawTail.indexOf('#');

    let title = '';
    let remainderText = '';

    if (inlineTitleEndIndex >= 0)
    {
        title = rawTail.slice(0, inlineTitleEndIndex).trim();
        remainderText = rawTail.slice(inlineTitleEndIndex + 1).trimStart();
    }
    else
    {
        const rawTitle = rawTail.trim();
        title = rawTitle.split(/\s(?=#)|(?=\n#)|(?= #)/)[0].trim();
    }

    return {
        key: `${major}.${minor}.${patch}`,
        title: title || `Section ${major}.${minor}.${patch}`,
        numbers: [major, minor, patch],
        level: patch > 0 ? 2 : (minor > 0 ? 1 : 0),
        remainderText,
        charsToRemove: rawText.length - remainderText.length,
    };
}

function stripGoogleDocComments(root)
{
    if (!root || !root.querySelectorAll) return;

    try
    {
        root.querySelectorAll('a[id^="cmnt"][href^="#cmnt_ref"]').forEach((anchor) =>
        {
            const block = anchor.closest('div');
            if (block)
            {
                block.remove();
                return;
            }

            const paragraph = anchor.closest('p');
            if (paragraph)
            {
                paragraph.remove();
                return;
            }

            anchor.remove();
        });

        root.querySelectorAll('a[id^="cmnt_ref"][href^="#cmnt"]').forEach((anchor) =>
        {
            anchor.remove();
        });
    }
    catch (e)
    {}
}

function stripLeadingTextFromNode(node, charsToRemove)
{
    if (!node || !charsToRemove) return charsToRemove;

    if (node.nodeType === Node.TEXT_NODE)
    {
        const currentText = node.textContent || '';
        if (charsToRemove >= currentText.length)
        {
            node.textContent = '';
            return charsToRemove - currentText.length;
        }

        node.textContent = currentText.slice(charsToRemove);
        return 0;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return charsToRemove;

    let remaining = charsToRemove;
    Array.from(node.childNodes || []).forEach((childNode) =>
    {
        if (!remaining) return;
        remaining = stripLeadingTextFromNode(childNode, remaining);
    });

    return remaining;
}

function hasRenderableContent(node)
{
    if (!node) return false;
    if (node.nodeType === Node.TEXT_NODE) return Boolean(String(node.textContent || '').trim());
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    if (String(node.tagName || '').toLowerCase() === 'br') return true;
    return Array.from(node.childNodes || []).some((childNode) => hasRenderableContent(childNode));
}

function compareSectionOrder(left, right)
{
    const maxLen = Math.max(left.numbers.length, right.numbers.length);
    for (let index = 0; index <maxLen; index += 1)
    {
        const leftValue = Number(left.numbers[index] || 0);
        const rightValue = Number(right.numbers[index] || 0);
        if (leftValue !== rightValue) return leftValue - rightValue;
    }
    return 0;
}

function buildDocumentSections(root)
{
    if (!root) return {
        introNodes: [],
        sections: [],
        mainSections: []
    };

    const introNodes = [];
    const discoveredSections = [];
    const mainSections = [];
    let currentMainSection = null;
    let currentSubSection = null;
    let currentSection = null;

    Array.from(root.childNodes || []).forEach((node) =>
    {
        const marker = parseSectionMarker(node);
        if (marker)
        {
            const nextSection = {
                ...marker,
                contentNodes: [],
                childKeys: [],
                parentKey: null,
                rootKey: null,
            };

            if (marker.level === 0)
            {
                nextSection.rootKey = nextSection.key;
                currentMainSection = nextSection;
                currentSubSection = null;
                mainSections.push(nextSection);
            }
            else if (marker.level === 1)
            {
                nextSection.parentKey = currentMainSection ? currentMainSection.key : null;
                nextSection.rootKey = currentMainSection ? currentMainSection.key : nextSection.key;
                if (currentMainSection) currentMainSection.childKeys.push(nextSection.key);
                currentSubSection = nextSection;
            }
            else
            {
                const parentSection = currentSubSection || currentMainSection;
                nextSection.parentKey = parentSection ? parentSection.key : null;
                nextSection.rootKey = currentMainSection ? currentMainSection.key : nextSection.key;
                if (parentSection) parentSection.childKeys.push(nextSection.key);
            }

            currentSection = nextSection;
            discoveredSections.push(nextSection);

            if (marker.remainderText)
            {
                if (node.nodeType === Node.ELEMENT_NODE)
                {
                    const cleanedNode = node.cloneNode(true);
                    stripLeadingTextFromNode(cleanedNode, marker.charsToRemove);
                    if (hasRenderableContent(cleanedNode)) nextSection.contentNodes.push(cleanedNode);
                }
                else if (root.ownerDocument)
                {
                    nextSection.contentNodes.push(root.ownerDocument.createTextNode(marker.remainderText));
                }
            }
            return;
        }

        if (currentSection)
        {
            currentSection.contentNodes.push(node);
            return;
        }

        introNodes.push(node);
    });

    return {
        introNodes,
        sections: discoveredSections.sort(compareSectionOrder),
        mainSections: mainSections.sort(compareSectionOrder),
    };
}

function sectionContainsDescendant(sectionMap, ancestorKey, candidateKey)
{
    if (!ancestorKey || !candidateKey || ancestorKey === candidateKey) return false;

    let currentKey = candidateKey;
    while (currentKey)
    {
        const currentSection = sectionMap[currentKey];
        if (!currentSection || !currentSection.parentKey) return false;
        if (currentSection.parentKey === ancestorKey) return true;
        currentKey = currentSection.parentKey;
    }

    return false;
}

function renderDocumentChildren(nodes, handlers, keyPrefix)
{
    return nodes.map((node, index) => renderDocumentNode(node, handlers, `${keyPrefix}-${index}`)).filter(Boolean);
}

function isMediaOnlyContentNode(node)
{
    if (!node) return false;

    if (node.nodeType === Node.TEXT_NODE)
    {
        return !(node.textContent || '').trim();
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return true;

    const tag = String(node.tagName || '').toLowerCase();
    if (tag === 'img' || tag === 'video' || tag === 'iframe') return true;
    if (tag === 'br') return true;

    const childNodes = Array.from(node.childNodes || []);
    if (!childNodes.length) return true;

    return childNodes.every((childNode) => isMediaOnlyContentNode(childNode));
}

function isMediaOnlyBlockNode(node)
{
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;

    const childNodes = Array.from(node.childNodes || []);
    const hasMediaDescendant = childNodes.some((childNode) =>
    {
        if (!childNode || childNode.nodeType !== Node.ELEMENT_NODE) return false;
        const tag = String(childNode.tagName || '').toLowerCase();
        return tag === 'img' || tag === 'video' || tag === 'iframe' || Boolean(childNode.querySelector && childNode.querySelector('img, video, iframe'));
    });

    return hasMediaDescendant && childNodes.every((childNode) => isMediaOnlyContentNode(childNode));
}

function getMediaWrapperStyle(inputStyle)
{
    const output = {
        ...(inputStyle ||
        {})
    };

    return {
        ...output,
        display: output.display || 'block',
        margin: typeof output.margin === 'undefined' ? 0 : output.margin,
        lineHeight: output.lineHeight || 0,
    };
}

function getNodeDimensionValue(node, attributeName)
{
    if (!node || !attributeName || typeof node.getAttribute !== 'function') return '';

    const rawValue = String(node.getAttribute(attributeName) || '').trim();
    if (!rawValue) return '';
    if (/^\d+(?:\.\d+)?$/.test(rawValue)) return `${rawValue}px`;
    return rawValue;
}

function getImageLayoutStyle(node, nodeStyle)
{
    const width = nodeStyle && nodeStyle.width ? nodeStyle.width : getNodeDimensionValue(node, 'width');
    const height = nodeStyle && nodeStyle.height ? nodeStyle.height : getNodeDimensionValue(node, 'height');

    return {
        ...(nodeStyle ||
        {}),
        ...(width ?
        {
            width
        } :
        {}),
        ...(height ?
        {
            height
        } :
        {}),
    };
}

function isBlackTextColor(value)
{
    const normalized = String(value || '').trim().toLowerCase().replace(/\s+/g, '');
    if (!normalized) return false;

    return normalized === '#000' ||
        normalized === '#000000' ||
        normalized === 'black' ||
        normalized === 'rgb(0,0,0)' ||
        normalized === 'rgba(0,0,0,1)';
}

function getNodeStyle(node, documentStyles)
{
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return {};

    const output = {};
    const tagName = String(node.tagName || '').toLowerCase();

    if (documentStyles && documentStyles.tagStyles && documentStyles.tagStyles[tagName])
    {
        Object.assign(output, documentStyles.tagStyles[tagName]);
    }

    try
    {
        const classList = Array.from(node.classList || []);
        classList.forEach((className) =>
        {
            if (documentStyles && documentStyles.classStyles && documentStyles.classStyles[className])
            {
                Object.assign(output, documentStyles.classStyles[className]);
            }
        });
    }
    catch (e)
    {}

    const inlineStyle = node.getAttribute('style');
    if (inlineStyle) Object.assign(output, parseCssDeclarations(inlineStyle));

    if (isBlackTextColor(output.color)) output.color = '#ffffff';
    if (!output.textAlign) output.textAlign = 'left';
    return output;
}

function normalizeEmojiName(value)
{
    return String(value || '').trim().toLowerCase();
}

function normalizeEmojiClickSound(soundConfig)
{
    if (!soundConfig || typeof soundConfig !== 'object') return null;

    const src = String(soundConfig.src || '').trim();
    if (!src) return null;

    const parsedBaseVolume = Number(soundConfig.baseVolume);
    return {
        src,
        ...(Number.isFinite(parsedBaseVolume) ?
        {
            baseVolume: parsedBaseVolume
        } :
        {}),
    };
}

function normalizeEmojiDefinitions(definitions)
{
    if (!definitions || typeof definitions !== 'object') return {};

    return Object.entries(definitions).reduce((result, [rawName, definition]) =>
    {
        const normalizedKey = normalizeEmojiName(rawName).replace(/\s+/g, '');
        if (!normalizedKey) return result;

        const normalizedDefinition = definition && typeof definition === 'object' ? definition :
        {};
        result[normalizedKey] = {
            ...normalizedDefinition,
            name: normalizeEmojiName(normalizedDefinition.name || rawName).replace(/\s+/g, ''),
            fileName: normalizedDefinition.fileName || String(rawName || '').trim().replace(/\s+/g, ''),
            clickSound: normalizeEmojiClickSound(normalizedDefinition.clickSound),
        };
        return result;
    },
    {});
}

function getEmojiDefinition(emojiConfig, emojiName)
{
    const normalizedName = normalizeEmojiName(emojiName);
    if (!normalizedName) return null;

    const emojiDefinitions = emojiConfig && emojiConfig.emojis ? emojiConfig.emojis : null;
    const definition = emojiDefinitions ?
        emojiDefinitions[normalizedName] || emojiDefinitions[normalizedName.replace(/\s+/g, '')] :
        null;
    if (!definition || definition.enabled === false) return null;

    return {
        ...definition,
        name: normalizeEmojiName(definition.name || normalizedName).replace(/\s+/g, ''),
    };
}

function getEmojiSource(definition)
{
    if (!definition || !definition.name) return '';

    const fileName = String(definition.fileName || definition.name).trim();
    if (!fileName) return '';

    if (/\.[a-z0-9]+$/i.test(fileName))
    {
        return `/FRNC emojis/${fileName}`;
    }

    const extension = String(definition.extension || 'png').trim().replace(/^\./, '');
    return `/FRNC emojis/${fileName}.${extension}`;
}

function isGoogleDocCommentLink(node)
{
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;

    const href = String(node.getAttribute('href') || '').trim();
    if (!/^#cmnt(?:_ref)?\d+$/i.test(href)) return false;

    const text = String(node.textContent || '').trim();
    return /^\[[a-z]+\]$/i.test(text);
}

function renderTextWithEmojiTokens(value, emojiConfig, keyPrefix)
{
    const text = String(value || '');
    if (!text) return null;

    const output = [];
    const globalScale = Math.max(0.1, Number(emojiConfig && emojiConfig.globalScale) || 1);
    let lastIndex = 0;
    let matchedEmoji = false;

    EMOJI_TOKEN_PATTERN.lastIndex = 0;
    let match = EMOJI_TOKEN_PATTERN.exec(text);
    while (match)
    {
        const matchText = match[0];
        const matchStart = match.index;
        const matchEnd = matchStart + matchText.length;

        if (matchStart > lastIndex)
        {
            output.push( <React.Fragment key = {
                    `${keyPrefix}-text-${lastIndex}`
                } >
                {
                    text.slice(lastIndex, matchStart)
                } </React.Fragment>);
            }

            const definition = getEmojiDefinition(emojiConfig, match[1]);
            if (definition)
            {
                const emojiScale = Math.max(0.2, globalScale);
                const emojiSrc = getEmojiSource(definition);
                const emojiLabel = definition.label || definition.name;
                const canPlayClickSound = Boolean(definition.clickSound && definition.clickSound.src);

                if (emojiSrc)
                {
                    matchedEmoji = true;
                    const emojiImage = ( <img src = {
                            emojiSrc
                        }
                        alt = {
                            `:${definition.name}:`
                        }
                        title = {
                            emojiLabel
                        }
                        draggable = {
                            false
                        }
                        style = {
                            {
                                display: 'inline-block',
                                width: 'auto',
                                height: `${emojiScale}em`,
                                maxWidth: 'none',
                                userSelect: 'none',
                                pointerEvents: canPlayClickSound ? 'none' : 'auto',
                            }
                        }
                        />
                    );

                    if (canPlayClickSound)
                    {
                        output.push( <button key = {
                                `${keyPrefix}-emoji-${matchStart}`
                            }
                            type = "button"
                            aria-label = {
                                emojiLabel
                            }
                            title = {
                                emojiLabel
                            }
                            onClick = {
                                () => playAudioSourceConfig(definition.clickSound)
                            }
                            style = {
                                {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: 0,
                                    background: 'transparent',
                                    padding: 0,
                                    margin: '0 0.12em',
                                    verticalAlign: 'middle',
                                    transform: 'translateY(-0.10em)',
                                    cursor: 'pointer',
                                    lineHeight: 0,
                                    userSelect: 'none',
                                }
                            } >
                            {
                                emojiImage
                            } </button>,
                        );
                    }
                    else
                    {
                        output.push( <span key = {
                                `${keyPrefix}-emoji-${matchStart}`
                            }
                            title = {
                                emojiLabel
                            }
                            style = {
                                {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 0.12em',
                                    verticalAlign: 'middle',
                                    transform: 'translateY(-0.10em)',
                                    lineHeight: 0,
                                }
                            } >
                            {
                                emojiImage
                            } </span>,
                        );
                    }
                }
                else
                {
                    output.push( <React.Fragment key = {
                            `${keyPrefix}-raw-${matchStart}`
                        } >
                        {
                            matchText
                        } </React.Fragment>);
                    }
                }
                else
                {
                    output.push( <React.Fragment key = {
                            `${keyPrefix}-raw-${matchStart}`
                        } >
                        {
                            matchText
                        } </React.Fragment>);
                    }

                    lastIndex = matchEnd;
                    match = EMOJI_TOKEN_PATTERN.exec(text);
                }

                if (lastIndex <text.length)
                {
                    output.push( <React.Fragment key = {
                            `${keyPrefix}-text-${lastIndex}`
                        } >
                        {
                            text.slice(lastIndex)
                        } </React.Fragment>);
                    }

                    if (!matchedEmoji) return <React.Fragment key = {
                        keyPrefix
                    } >
                    {
                        text
                    } </React.Fragment>;
                    return output;
                }

                function renderDocumentNode(node, handlers, key)
                {
                    if (!node) return null;

                    if (node.nodeType === Node.TEXT_NODE)
                    {
                        const value = node.textContent || '';
                        return renderTextWithEmojiTokens(value, handlers.emojiConfig, key);
                    }

                    if (node.nodeType !== Node.ELEMENT_NODE) return null;

                    const tag = String(node.tagName || '').toLowerCase();
                    if (!tag || tag === 'style' || tag === 'script' || tag === 'noscript' || tag === 'meta' || tag === 'link' || tag === 'title') return null;

                    const children = renderDocumentChildren(Array.from(node.childNodes || []), handlers, `${key}-child`);
                    const nodeStyle = getNodeStyle(node, handlers.documentStyles);

                    if (tag === 'img')
                    {
                        const src = toDocumentAssetUrl(node.getAttribute('src') || '');
                        if (!src) return null;

                        const alt = node.getAttribute('alt') || 'Document image';
                        const imageLayoutStyle = getImageLayoutStyle(node, nodeStyle);
                        const imageFrameStyle = getMediaWrapperStyle(imageLayoutStyle);
                        const frameDisplay = imageFrameStyle.display === 'inline' || imageFrameStyle.display === 'inline-block' ?
                            'inline-flex' :
                            'flex';
                        return ( <span key = {
                                key
                            }
                            style = {
                                {
                                    ...imageFrameStyle,
                                    display: frameDisplay,
                                    justifyContent: imageFrameStyle.justifyContent || 'center',
                                    alignItems: imageFrameStyle.alignItems || 'center',
                                    boxSizing: 'border-box',
                                    maxWidth: imageFrameStyle.maxWidth || '100%',
                                    verticalAlign: imageFrameStyle.verticalAlign || 'top',
                                }
                            } >
                            <button type = "button"
                            onClick = {
                                () => handlers.openMedia(
                                {
                                    type: 'image',
                                    src,
                                    alt
                                })
                            }
                            style = {
                                {
                                    border: 0,
                                    background: 'transparent',
                                    padding: 0,
                                    cursor: 'zoom-in',
                                    maxWidth: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    boxSizing: 'border-box',
                                    width: imageLayoutStyle.width ? '100%' : 'fit-content',
                                }
                            } >
                            <img src = {
                                src
                            }
                            alt = {
                                alt
                            }
                            style = {
                                {
                                    display: 'block',
                                    maxWidth: '100%',
                                    width: imageLayoutStyle.width || 'auto',
                                    height: imageLayoutStyle.height || 'auto',
                                    maxHeight: imageLayoutStyle.height ? imageLayoutStyle.height : 'min(54vh, 680px)',
                                    objectFit: 'contain',
                                    margin: 0,
                                    transform: imageLayoutStyle.transform,
                                    WebkitTransform: imageLayoutStyle.WebkitTransform,
                                }
                            }
                            /> </button> </span>
                        );
                    }

                    if (tag === 'video')
                    {
                        const descriptor = getVideoSourceFromElement(node);
                        if (!descriptor || !descriptor.src) return null;

                        return ( <div key = {
                                key
                            }
                            style = {
                                {
                                    margin: 0,
                                    display: 'grid',
                                    gap: 10
                                }
                            } >
                            <video controls preload = "metadata"
                            style = {
                                {
                                    display: 'block',
                                    width: '100%',
                                    maxHeight: 'min(54vh, 640px)',
                                    background: '#000'
                                }
                            } >
                            <source src = {
                                descriptor.src
                            }
                            /> </video> <button type = "button"
                            onClick = {
                                () => handlers.openMedia(
                                {
                                    type: 'video',
                                    src: descriptor.src,
                                    title: 'Document video'
                                })
                            }
                            style = {
                                {
                                    justifySelf: 'start',
                                    padding: '0.55rem 0.95rem',
                                    border: '1px solid rgba(255,255,255,0.22)',
                                    background: 'rgba(255,255,255,0.04)',
                                    color: '#fff',
                                    cursor: 'pointer'
                                }
                            } >
                            Inspect Video </button> </div>
                        );
                    }

                    if (tag === 'iframe')
                    {
                        const src = toAbsoluteUrl(node.getAttribute('src') || '');
                        if (!src) return null;

                        return ( <div key = {
                                key
                            }
                            style = {
                                {
                                    margin: 0,
                                    display: 'grid',
                                    gap: 10
                                }
                            } >
                            <div style = {
                                {
                                    position: 'relative',
                                    width: '100%',
                                    aspectRatio: '16 / 9',
                                    background: '#000'
                                }
                            } >
                            <iframe src = {
                                src
                            }
                            title = "Document embed"
                            style = {
                                {
                                    position: 'absolute',
                                    inset: 0,
                                    width: '100%',
                                    height: '100%',
                                    border: 0
                                }
                            }
                            allow = "autoplay; encrypted-media; picture-in-picture; fullscreen"
                            allowFullScreen />
                            </div> <button type = "button"
                            onClick = {
                                () => handlers.openMedia(
                                {
                                    type: 'embed',
                                    src,
                                    title: 'Document video embed'
                                })
                            }
                            style = {
                                {
                                    justifySelf: 'start',
                                    padding: '0.55rem 0.95rem',
                                    border: '1px solid rgba(255,255,255,0.22)',
                                    background: 'rgba(255,255,255,0.04)',
                                    color: '#fff',
                                    cursor: 'pointer'
                                }
                            } >
                            Inspect Video </button> </div>
                        );
                    }

                    if (tag === 'a')
                    {
                        if (isGoogleDocCommentLink(node)) return null;

                        const href = toAbsoluteUrl(node.getAttribute('href') || '');
                        const video = getVideoDescriptor(href);

                        if (video)
                        {
                            return ( <button key = {
                                    key
                                }
                                type = "button"
                                onClick = {
                                    () => handlers.openMedia(
                                    {
                                        ...video,
                                        title: href
                                    })
                                }
                                style = {
                                    {
                                        border: 0,
                                        padding: 0,
                                        background: 'transparent',
                                        color: '#9ed0ff',
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                        font: 'inherit'
                                    }
                                } >
                                {
                                    children.length ? children : 'Open video'
                                } </button>
                            );
                        }

                        return ( <a key = {
                                key
                            }
                            href = {
                                href || undefined
                            }
                            target = "_blank"
                            rel = "noopener noreferrer"
                            style = {
                                {
                                    ...nodeStyle,
                                    color: nodeStyle.color || '#9ed0ff'
                                }
                            } >
                            {
                                children.length ? children : (href || 'Open link')
                            } </a>
                        );
                    }

                    if (tag === 'table')
                    {
                        return ( <div key = {
                                key
                            }
                            style = {
                                BLOCK_STYLES.tableWrap
                            } >
                            <table style = {
                                BLOCK_STYLES.table
                            } >
                            {
                                children
                            } </table> </div>
                        );
                    }

                    if (tag === 'thead' || tag === 'tbody' || tag === 'tr')
                    {
                        const Tag = tag;
                        return <Tag key = {
                            key
                        } >
                        {
                            children
                        } </Tag>;
                    }

                    if (tag === 'td' || tag === 'th')
                    {
                        const Tag = tag;
                        return <Tag key = {
                            key
                        }
                        style = {
                            {
                                ...BLOCK_STYLES[tag],
                                ...nodeStyle
                            }
                        } >
                        {
                            children
                        } </Tag>;
                    }

                    if (tag === 'hr')
                    {
                        return <hr key = {
                            key
                        }
                        style = {
                            BLOCK_STYLES.hr
                        }
                        />;
                    }

                    if (tag === 'br')
                    {
                        return <br key = {
                            key
                        }
                        />;
                    }

                    if (tag === 'strong' || tag === 'b') return <strong key = {
                        key
                    }
                    style = {
                        nodeStyle
                    } >
                    {
                        children
                    } </strong>;
                    if (tag === 'em' || tag === 'i') return <em key = {
                        key
                    }
                    style = {
                        nodeStyle
                    } >
                    {
                        children
                    } </em>;
                    if (tag === 'u') return <u key = {
                        key
                    }
                    style = {
                        nodeStyle
                    } >
                    {
                        children
                    } </u>;
                    if (tag === 's' || tag === 'strike') return <s key = {
                        key
                    }
                    style = {
                        nodeStyle
                    } >
                    {
                        children
                    } </s>;
                    if (tag === 'span')
                    {
                        if (isMediaOnlyBlockNode(node))
                        {
                            return <div key = {
                                key
                            }
                            style = {
                                getMediaWrapperStyle(nodeStyle)
                            } >
                            {
                                children
                            } </div>;
                        }

                        return <span key = {
                            key
                        }
                        style = {
                            nodeStyle
                        } >
                        {
                            children
                        } </span>;
                    }
                    if (tag === 'code') return <code key = {
                        key
                    }
                    style = {
                        {
                            ...BLOCK_STYLES.code,
                            ...nodeStyle
                        }
                    } >
                    {
                        children
                    } </code>;
                    if (tag === 'pre') return <pre key = {
                        key
                    }
                    style = {
                        {
                            ...BLOCK_STYLES.pre,
                            ...nodeStyle
                        }
                    } >
                    {
                        children
                    } </pre>;
                    if (tag === 'ul' || tag === 'ol' || tag === 'li' || tag === 'p' || tag === 'div' || tag === 'blockquote' || /^h[1-6]$/.test(tag))
                    {
                        const isMediaOnlyBlock = (tag === 'p' || tag === 'div') && isMediaOnlyBlockNode(node);
                        const Tag = tag === 'p' && isMediaOnlyBlock ? 'div' : tag;
                        const blockStyle = {
                            ...(BLOCK_STYLES[tag] ||
                            {}),
                            ...nodeStyle
                        };

                        if (isMediaOnlyBlock)
                        {
                            blockStyle.margin = 0;
                        }

                        return <Tag key = {
                            key
                        }
                        style = {
                            blockStyle
                        } >
                        {
                            children
                        } </Tag>;
                    }

                    return <React.Fragment key = {
                        key
                    } >
                    {
                        children
                    } </React.Fragment>;
                }

                async function readServerAccess()
                {
                    const response = await fetch(FRNC_ACCESS_ENDPOINT,
                    {
                        method: 'GET',
                        credentials: 'same-origin',
                    });

                    const payload = await response.json().catch(() => (
                    {}));
                    if (!response.ok)
                    {
                        throw new Error(payload && payload.error ? payload.error : 'The server IS DEAD, FUCK! Access status could not be retrieved.');
                    }

                    return payload;
                }

                async function clearServerAccess()
                {
                    await fetch(FRNC_ACCESS_ENDPOINT,
                    {
                        method: 'DELETE',
                        credentials: 'same-origin',
                    }).catch(() =>
                    {});
                }

                function getSoundConfig(audioConfig, soundKey)
                {
                    try
                    {
                        const sounds = audioConfig && audioConfig.sounds ? audioConfig.sounds : DEFAULT_AUDIO_CONFIG.sounds;
                        const configuredSound = sounds && sounds[soundKey] ? sounds[soundKey] : null;
                        const fallbackSound = DEFAULT_AUDIO_CONFIG.sounds[soundKey] || null;
                        return configuredSound || fallbackSound;
                    }
                    catch (e)
                    {
                        return DEFAULT_AUDIO_CONFIG.sounds[soundKey] || null;
                    }
                }

                function playConfiguredSound(audioConfig, soundKey)
                {
                    const sound = getSoundConfig(audioConfig, soundKey);
                    playAudioSourceConfig(sound);
                }

                function playAudioSourceConfig(sound)
                {
                    if (!sound || !sound.src) return;

                    try
                    {
                        const sfx = new Audio(sound.src);
                        sfx._baseVolume = typeof sound.baseVolume === 'number' ? sound.baseVolume : 1.0;
                        try
                        {
                            masterVolume.applyToElement(sfx);
                        }
                        catch (e)
                        {}
                        try
                        {
                            sfx.play().catch(() =>
                            {});
                        }
                        catch (e)
                        {}
                    }
                    catch (e)
                    {}
                }

                function createBeatSequenceDisplay()
                {
                    return {
                        firstLine: '',
                        secondLine: '',
                        activeLine: 0,
                        activeBeat: 0,
                        tiltFromDeg: 0,
                        tiltToDeg: 0,
                    };
                }

                function getBeatSequenceConfig(mode)
                {
                    if (mode === FRNC_SEQUENCE_REFRESH)
                    {
                        return {
                            noBounceBeats: FRNC_REFRESH_NO_BOUNCE_BEATS,
                            tiltResetBeat: FRNC_REFRESH_TILT_RESET_BEAT,
                            totalBeats: FRNC_REFRESH_ENTRY_TOTAL_BEATS,
                            sequence: FRNC_REFRESH_ENTRY_SEQUENCE,
                            audioKey: 'refreshBeat',
                            useSecondLine: true,
                        };
                    }

                    if (mode === FRNC_SEQUENCE_EXIT)
                    {
                        return {
                            noBounceBeats: FRNC_EXIT_NO_BOUNCE_BEATS,
                            tiltResetBeat: FRNC_EXIT_TILT_RESET_BEAT,
                            totalBeats: FRNC_EXIT_TOTAL_BEATS,
                            sequence: FRNC_EXIT_SEQUENCE,
                            audioKey: 'exitBeat',
                            useSecondLine: true,
                            tiltDirection: 'counter-clockwise',
                            exitRedirect: true,
                        };
                    }

                    return {
                        noBounceBeats: FRNC_PASS_ENTRY_NO_BOUNCE_BEATS,
                        tiltResetBeat: FRNC_PASS_ENTRY_TILT_RESET_BEAT,
                        totalBeats: FRNC_PASS_ENTRY_SEQUENCE.length,
                        sequence: FRNC_PASS_ENTRY_SEQUENCE,
                        audioKey: 'passEntryBeat',
                        useSecondLine: true,
                        tiltDirection: 'alternate',
                        exitRedirect: false,
                    };
                }

                function getBeatSequenceTiltTarget(beatNumber, currentTiltDeg, config)
                {
                    if (!beatNumber) return currentTiltDeg || 0;
                    if (config && config.exitRedirect && beatNumber >= config.tiltResetBeat) return -FRNC_PASS_ENTRY_TILT_DEG;
                    if (config && beatNumber === config.tiltResetBeat) return 0;
                    if (config && config.noBounceBeats.has(beatNumber)) return currentTiltDeg || 0;
                    if (config && config.tiltDirection === 'counter-clockwise')
                    {
                        return (currentTiltDeg || 0) - FRNC_PASS_ENTRY_TILT_DEG;
                    }
                    if (!currentTiltDeg) return FRNC_PASS_ENTRY_TILT_DEG;
                    return currentTiltDeg > 0 ? -FRNC_PASS_ENTRY_TILT_DEG : FRNC_PASS_ENTRY_TILT_DEG;
                }

                function applyBeatSequenceStep(currentDisplay, step, beatNumber, config)
                {
                    const nextDisplay = currentDisplay || createBeatSequenceDisplay();
                    const previousTiltDeg = typeof nextDisplay.tiltToDeg === 'number' ? nextDisplay.tiltToDeg : 0;
                    const nextTiltDeg = getBeatSequenceTiltTarget(beatNumber, previousTiltDeg, config);

                    if (!step)
                    {
                        return {
                            ...nextDisplay,
                            activeBeat: beatNumber || nextDisplay.activeBeat,
                            tiltFromDeg: previousTiltDeg,
                            tiltToDeg: nextTiltDeg,
                        };
                    }

                    if (step.type === 'append')
                    {
                        return {
                            ...nextDisplay,
                            firstLine: step.lineIndex === 0 ? `${nextDisplay.firstLine}${step.value}` : nextDisplay.firstLine,
                            secondLine: step.lineIndex === 1 ? `${nextDisplay.secondLine}${step.value}` : nextDisplay.secondLine,
                            activeLine: typeof step.lineIndex === 'number' ? step.lineIndex : nextDisplay.activeLine,
                            activeBeat: beatNumber,
                            tiltFromDeg: previousTiltDeg,
                            tiltToDeg: nextTiltDeg,
                        };
                    }

                    if (step.type === 'set')
                    {
                        return {
                            ...nextDisplay,
                            firstLine: step.lineIndex === 0 ? String(step.value || '') : nextDisplay.firstLine,
                            secondLine: step.lineIndex === 1 ? String(step.value || '') : nextDisplay.secondLine,
                            activeLine: typeof step.lineIndex === 'number' ? step.lineIndex : nextDisplay.activeLine,
                            activeBeat: beatNumber,
                            tiltFromDeg: previousTiltDeg,
                            tiltToDeg: nextTiltDeg,
                        };
                    }

                    if (step.type === 'set-lines')
                    {
                        return {
                            ...nextDisplay,
                            firstLine: String(step.firstLine || ''),
                            secondLine: String(step.secondLine || ''),
                            activeLine: typeof step.activeLine === 'number' ? step.activeLine : nextDisplay.activeLine,
                            activeBeat: beatNumber,
                            tiltFromDeg: previousTiltDeg,
                            tiltToDeg: nextTiltDeg,
                        };
                    }

                    if (step.type === 'switch-line')
                    {
                        return {
                            ...nextDisplay,
                            activeLine: typeof step.lineIndex === 'number' ? step.lineIndex : nextDisplay.activeLine,
                            activeBeat: beatNumber,
                            tiltFromDeg: previousTiltDeg,
                            tiltToDeg: nextTiltDeg,
                        };
                    }

                    return {
                        ...nextDisplay,
                        activeBeat: beatNumber,
                        tiltFromDeg: previousTiltDeg,
                        tiltToDeg: nextTiltDeg,
                    };
                }

                function createPreloadedAudioElement(sound)
                {
                    if (!sound || !sound.src) return null;

                    try
                    {
                        return createPreloadedAudio(sound.src,
                        {
                            baseVolume: typeof sound.baseVolume === 'number' ? sound.baseVolume : 1.0,
                            loop: false,
                            applyMaster: true,
                        });
                    }
                    catch (e)
                    {
                        return null;
                    }
                }

                function isPreloadedAudioReady(audio)
                {
                    if (!audio) return false;

                    try
                    {
                        return audio.readyState >= 2;
                    }
                    catch (e)
                    {
                        return false;
                    }
                }

                function beginPreloadedAudioLoad(audio, onReady, onFailed)
                {
                    if (!audio)
                    {
                        if (typeof onFailed === 'function') onFailed();
                        return () =>
                        {};
                    }

                    let settled = false;
                    const markReady = () =>
                    {
                        if (settled) return;
                        settled = true;
                        if (typeof onReady === 'function') onReady();
                    };
                    const markFailed = () =>
                    {
                        if (settled) return;
                        settled = true;
                        if (typeof onFailed === 'function') onFailed();
                    };

                    audio.addEventListener('canplaythrough', markReady);
                    audio.addEventListener('canplay', markReady);
                    audio.addEventListener('loadeddata', markReady);
                    audio.addEventListener('loadedmetadata', markReady);
                    audio.addEventListener('error', markFailed);

                    try
                    {
                        audio.load();
                    }
                    catch (e)
                    {}

                    if (isPreloadedAudioReady(audio))
                    {
                        markReady();
                    }

                    return () =>
                    {
                        audio.removeEventListener('canplaythrough', markReady);
                        audio.removeEventListener('canplay', markReady);
                        audio.removeEventListener('loadeddata', markReady);
                        audio.removeEventListener('loadedmetadata', markReady);
                        audio.removeEventListener('error', markFailed);
                    };
                }

                function stopPreloadedAudioElement(audio)
                {
                    if (!audio) return;

                    try
                    {
                        audio.pause();
                        audio.currentTime = 0;
                    }
                    catch (e)
                    {}
                }

                function playPreloadedAudioElement(audio)
                {
                    if (!audio) return;

                    try
                    {
                        audio.pause();
                        audio.currentTime = 0;
                        try
                        {
                            masterVolume.applyToElement(audio);
                        }
                        catch (e)
                        {}
                        try
                        {
                            audio.play().catch(() =>
                            {});
                        }
                        catch (e)
                        {}
                    }
                    catch (e)
                    {}
                }

                function playPreloadedAudioElementAndWait(audio)
                {
                    if (!audio) return Promise.resolve(false);

                    return new Promise((resolve) =>
                    {
                        let settled = false;
                        const durationSeconds = Number(audio.duration);
                        const timeoutMs = Number.isFinite(durationSeconds) && durationSeconds > 0 ?
                            Math.min(4000, Math.max(1000, Math.round(durationSeconds * 1000) + 120)) :
                            1800;
                        const timeout = setTimeout(finish, timeoutMs);

                        function finish(success = true)
                        {
                            if (settled) return;
                            settled = true;
                            clearTimeout(timeout);
                            audio.removeEventListener('ended', finish);
                            audio.removeEventListener('error', finish);
                            resolve(success);
                        }

                        audio.addEventListener('ended', finish);
                        audio.addEventListener('error', finish);

                        try
                        {
                            audio.pause();
                            audio.currentTime = 0;
                            masterVolume.applyToElement(audio);
                            const playPromise = audio.play();
                            if (playPromise && typeof playPromise.catch === 'function')
                            {
                                playPromise.catch(() => finish(false));
                            }
                        }
                        catch (e)
                        {
                            finish(false);
                        }
                    });
                }

                function stripFileExtension(value)
                {
                    return String(value || '').replace(/\.[^./\\]+$/, '');
                }

                function encodePublicPathSegment(value)
                {
                    return String(value || '')
                        .split('/')
                        .map((part) => encodeURIComponent(part))
                        .join('/');
                }

                function normalizePlaylistTrack(track)
                {
                    const id = String(track && track.id ? track.id : '').trim();
                    const audioFile = String(track && track.audioFile ? track.audioFile : '').trim();
                    const rawBaseVolume = Number(track && track.baseVolume);
                    const baseVolume = Number.isFinite(rawBaseVolume) ? Math.max(0, rawBaseVolume) : 1.0;

                    if (!id || !audioFile) return null;

                    return {
                        id,
                        audioFile,
                        baseVolume,
                    };
                }

                function getPlaylistTrackSrc(track)
                {
                    if (!track || !track.audioFile) return '';
                    return `/Audio/FRNC/Playlist/${encodePublicPathSegment(track.audioFile)}`;
                }

                function getPlaylistTrackLabel(track)
                {
                    if (!track) return '';
                    return stripFileExtension(track.audioFile);
                }

                function createAudioLoadState(keys, value = 'idle')
                {
                    return keys.reduce((accumulator, key) =>
                    {
                        accumulator[key] = value;
                        return accumulator;
                    },
                    {});
                }

                function isAudioLoadStateReady(status)
                {
                    return status === 'ready' || status === 'failed';
                }

                function areAudioKeysReady(loadState, keys)
                {
                    return keys.every((key) => isAudioLoadStateReady(loadState && loadState[key]));
                }

                function createDocState(overrides = {})
                {
                    return {
                        status: 'idle',
                        html: '',
                        error: '',
                        progress: 0,
                        progressLabel: '',
                        ...overrides,
                    };
                }

                function normalizeDocProgress(value)
                {
                    const numericValue = Number(value);
                    if (!Number.isFinite(numericValue)) return 0;
                    return Math.max(0, Math.min(100, Math.round(numericValue)));
                }

                function getDocLoadLabel(stage)
                {
                    if (stage === 'preparing') return 'Fetching doc...';
                    if (stage === 'waiting') return 'Fetching doc. Waiting for Google Doc to respond...';
                    if (stage === 'downloading') return 'Downloading doc...';
                    if (stage === 'parsing') return 'Processing doc...';
                    if (stage === 'ready') return 'Doc ready.';
                    return '';
                }

                export default function FRncSuperSecretStrats()
                {
                    const [steamLoginUrl, setSteamLoginUrl] = useState('');
                    const [steamProfile, setSteamProfile] = useState(null);
                    const [error, setError] = useState('');
                    const [showContentUi, setShowContentUi] = useState(false);
                    const [docState, setDocState] = useState(() => createDocState());
                    const [activeMedia, setActiveMedia] = useState(null);
                    const [grantStage, setGrantStage] = useState('idle');
                    const [audioConfig, setAudioConfig] = useState(DEFAULT_AUDIO_CONFIG);
                    const [emojiConfig, setEmojiConfig] = useState(DEFAULT_EMOJI_CONFIG);
                    const [activeRootKey, setActiveRootKey] = useState(null);
                    const [activeSectionKey, setActiveSectionKey] = useState(null);
                    const [pendingScrollSectionKey, setPendingScrollSectionKey] = useState(null);
                    const [expandedSectionKeys, setExpandedSectionKeys] = useState(
                    {});
                    const [beatSequenceDisplay, setBeatSequenceDisplay] = useState(() => createBeatSequenceDisplay());
                    const [beatSequenceMode, setBeatSequenceMode] = useState(FRNC_SEQUENCE_ENTRY);
                    const [docUiIntroState, setDocUiIntroState] = useState('idle');
                    const [docMusicPlayerEnabled, setDocMusicPlayerEnabled] = useState(false);
                    const [docMusicPlayerPaused, setDocMusicPlayerPaused] = useState(true);
                    const [docMusicPlaylist, setDocMusicPlaylist] = useState([]);
                    const [docMusicTrackIndex, setDocMusicTrackIndex] = useState(0);
                    const [beatAudioLoadState, setBeatAudioLoadState] = useState(
                    {
                        passEntryBeat: 'idle',
                        refreshBeat: 'idle',
                        exitBeat: 'idle',
                    });
                    const [preloadedUiAudioLoadState, setPreloadedUiAudioLoadState] = useState(() => createAudioLoadState(FRNC_PRELOADED_UI_AUDIO_KEYS));
                    const [imageInspectTransform, setImageInspectTransform] = useState(
                    {
                        scale: 1,
                        x: 0,
                        y: 0
                    });
                    const [isAccessStatusLoading, setIsAccessStatusLoading] = useState(true);
                    const sectionRefs = useRef(
                    {});
                    const passEntryBeatAudioRef = useRef(null);
                    const refreshBeatAudioRef = useRef(null);
                    const exitBeatAudioRef = useRef(null);
                    const docMusicAudioRef = useRef(null);
                    const docMusicAutoplayHandledRef = useRef(false);
                    const preloadedUiAudioRefs = useRef(
                    {});
                    const audioConfigRef = useRef(DEFAULT_AUDIO_CONFIG);
                    const imageInspectDragRef = useRef(
                    {
                        pointerId: null,
                        startX: 0,
                        startY: 0,
                        originX: 0,
                        originY: 0
                    });

                    useEffect(() =>
                    {
                        let isCancelled = false;

                        const syncServerAccess = async () =>
                        {
                            setIsAccessStatusLoading(true);

                            try
                            {
                                const accessPayload = await readServerAccess();
                                if (isCancelled) return;

                                if (accessPayload.profile)
                                {
                                    setSteamProfile(accessPayload.profile);
                                }

                                const callbackAccess = new URLSearchParams(window.location.search).get('access');
                                if (callbackAccess)
                                {
                                    window.history.replaceState({}, document.title, window.location.pathname);
                                }

                                if (callbackAccess === 'granted')
                                {
                                    setError('');
                                    const accessGrantedAudio = preloadedUiAudioRefs.current.accessGranted;
                                    if (accessGrantedAudio)
                                    {
                                        await playPreloadedAudioElementAndWait(accessGrantedAudio);
                                    }
                                    else
                                    {
                                        playConfiguredSound(audioConfigRef.current, 'accessGranted');
                                    }
                                    if (isCancelled) return;
                                    setBeatSequenceMode(FRNC_SEQUENCE_ENTRY);
                                    setGrantStage('await-drop');
                                    return;
                                }

                                if (callbackAccess === 'denied')
                                {
                                    setError('DENIED: You are not part of the team.');
                                }
                                else if (callbackAccess === 'error')
                                {
                                    setError('DENIED: Steam login could not be verified.');
                                }

                                if (accessPayload.authenticated)
                                {
                                    setError('');
                                    setBeatSequenceMode(FRNC_SEQUENCE_REFRESH);
                                    setGrantStage('refresh-beat-sequence');
                                }
                                else if (accessPayload.loginUrl)
                                {
                                    setSteamLoginUrl(accessPayload.loginUrl);
                                }
                            }
                            catch (e)
                            {
                                if (isCancelled) return;
                                setError(e && e.message ? e.message : 'Who is this guy? Unable to verify access status.');
                            }
                            finally
                            {
                                if (!isCancelled) setIsAccessStatusLoading(false);
                            }
                        };

                        syncServerAccess();

                        return () =>
                        {
                            isCancelled = true;
                        };
                    }, []);

                    const shellStyle = useMemo(() => (
                    {
                        height: '100vh',
                        background: '#050505',
                        color: '#f5f5f5',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 24,
                        fontFamily: MAIN_FONT_STACK,
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                    }), []);

                    const contentShellStyle = useMemo(() => (
                    {
                        position: 'relative',
                        width: 'min(96vw, 1180px)',
                        height: 'calc(100vh - 48px)',
                        overflow: 'hidden',
                    }), []);

                    const contentLayoutStyle = useMemo(() => (
                    {
                        position: 'absolute',
                        inset: 0,
                        display: 'grid',
                        gridTemplateRows: '1fr',
                        paddingTop: 'clamp(52px, 7vw, 82px)',
                        overflow: 'hidden',
                    }), []);

                    const beginButtonTextStyle = useMemo(() => (
                    {
                        fontWeight: 600,
                        letterSpacing: '0.6px',
                        color: '#fff',
                    }), []);

                    const titleAnchorStyle = useMemo(() => (
                    {
                        ...beginButtonTextStyle,
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        zIndex: 3,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        fontSize: 'clamp(1.35rem, 2.55vw, 2rem)',
                        textTransform: 'uppercase',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                        transformOrigin: 'center center',
                        pointerEvents: 'none',
                    }), [beginButtonTextStyle]);

                    const isPassEntryBeatReady = beatAudioLoadState.passEntryBeat === 'ready';
                    const isRefreshBeatReady = beatAudioLoadState.refreshBeat === 'ready';
                    const isExitBeatReady = beatAudioLoadState.exitBeat === 'ready';
                    const isPasswordStageAudioReady = areAudioKeysReady(preloadedUiAudioLoadState, FRNC_PASSWORD_STAGE_AUDIO_KEYS) && isPassEntryBeatReady;
                    const isContentStageAudioReady = areAudioKeysReady(preloadedUiAudioLoadState, FRNC_CONTENT_STAGE_AUDIO_KEYS);
                    const currentDocMusicTrack = docMusicPlaylist[docMusicTrackIndex] || null;
                    const currentDocMusicTrackLabel = getPlaylistTrackLabel(currentDocMusicTrack);
                    const steamClassIconDefinition = getEmojiDefinition(emojiConfig, steamProfile && FRNC_STEAM_CLASS_ICONS[steamProfile.steamId]);
                    const steamClassIconSource = getEmojiSource(steamClassIconDefinition);

                    useEffect(() =>
                    {
                        audioConfigRef.current = audioConfig;
                    }, [audioConfig]);

                    useEffect(() =>
                    {
                        let cancelled = false;

                        const loadAudioConfig = async () =>
                        {
                            try
                            {
                                const response = await fetch(FRNC_AUDIO_CONFIG_URL,
                                {
                                    cache: 'no-store'
                                });
                                const data = await response.json();
                                if (!cancelled && data && typeof data === 'object')
                                {
                                    setAudioConfig(
                                    {
                                        ...DEFAULT_AUDIO_CONFIG,
                                        ...data,
                                        sounds:
                                        {
                                            ...DEFAULT_AUDIO_CONFIG.sounds,
                                            ...(data && data.sounds ? data.sounds :
                                            {}),
                                        },
                                    });
                                }
                            }
                            catch (e)
                            {
                                if (!cancelled) setAudioConfig(DEFAULT_AUDIO_CONFIG);
                            }
                        };

                        loadAudioConfig();
                        return () =>
                        {
                            cancelled = true;
                        };
                    }, []);

                    useEffect(() =>
                    {
                        let cancelled = false;

                        const loadPlaylistConfig = async () =>
                        {
                            try
                            {
                                const response = await fetch(FRNC_PLAYLIST_CONFIG_URL,
                                {
                                    cache: 'no-store'
                                });
                                const data = await response.json();
                                const nextTracks = Array.isArray(data && data.tracks) ?
                                    data.tracks.map((track) => normalizePlaylistTrack(track)).filter(Boolean) :
                                    [];

                                if (!cancelled)
                                {
                                    setDocMusicPlaylist(nextTracks);
                                }
                            }
                            catch (e)
                            {
                                if (!cancelled)
                                {
                                    setDocMusicPlaylist([]);
                                }
                            }
                        };

                        loadPlaylistConfig();
                        return () =>
                        {
                            cancelled = true;
                        };
                    }, []);

                    useEffect(() =>
                    {
                        if (!docMusicPlaylist.length)
                        {
                            setDocMusicTrackIndex(0);
                            return;
                        }

                        if (docMusicTrackIndex >= docMusicPlaylist.length)
                        {
                            setDocMusicTrackIndex(0);
                        }
                    }, [docMusicPlaylist, docMusicTrackIndex]);

                    useEffect(() =>
                    {
                        let cancelled = false;

                        const loadEmojiConfig = async () =>
                        {
                            try
                            {
                                const response = await fetch(FRNC_EMOJI_CONFIG_URL,
                                {
                                    cache: 'no-store'
                                });
                                const data = await response.json();
                                if (!cancelled && data && typeof data === 'object')
                                {
                                    setEmojiConfig(
                                    {
                                        ...DEFAULT_EMOJI_CONFIG,
                                        ...data,
                                        emojis:
                                        {
                                            ...normalizeEmojiDefinitions(DEFAULT_EMOJI_CONFIG.emojis),
                                            ...normalizeEmojiDefinitions(data && data.emojis ? data.emojis :
                                            {}),
                                        },
                                    });
                                }
                            }
                            catch (e)
                            {
                                if (!cancelled) setEmojiConfig(DEFAULT_EMOJI_CONFIG);
                            }
                        };

                        loadEmojiConfig();
                        return () =>
                        {
                            cancelled = true;
                        };
                    }, []);

                    useEffect(() =>
                    {
                        const sound = getSoundConfig(audioConfig, 'passEntryBeat');
                        setBeatAudioLoadState((current) => (
                        {
                            ...current,
                            passEntryBeat: 'loading'
                        }));
                        const audio = createPreloadedAudioElement(sound);
                        passEntryBeatAudioRef.current = audio;

                        if (!audio)
                        {
                            setBeatAudioLoadState((current) => (
                            {
                                ...current,
                                passEntryBeat: 'failed'
                            }));
                            return () =>
                            {
                                if (passEntryBeatAudioRef.current === audio)
                                {
                                    passEntryBeatAudioRef.current = null;
                                }
                            };
                        }

                        const markReady = () => setBeatAudioLoadState((current) => (
                        {
                            ...current,
                            passEntryBeat: 'ready'
                        }));
                        const markFailed = () => setBeatAudioLoadState((current) => (
                        {
                            ...current,
                            passEntryBeat: 'failed'
                        }));
                        const detachLoadListeners = beginPreloadedAudioLoad(audio, markReady, markFailed);

                        return () =>
                        {
                            detachLoadListeners();
                            stopPreloadedAudioElement(audio);
                            if (passEntryBeatAudioRef.current === audio)
                            {
                                passEntryBeatAudioRef.current = null;
                            }
                        };
                    }, [audioConfig]);

                    useEffect(() =>
                    {
                        const sound = getSoundConfig(audioConfig, 'refreshBeat');
                        setBeatAudioLoadState((current) => (
                        {
                            ...current,
                            refreshBeat: 'loading'
                        }));
                        const audio = createPreloadedAudioElement(sound);
                        refreshBeatAudioRef.current = audio;

                        if (!audio)
                        {
                            setBeatAudioLoadState((current) => (
                            {
                                ...current,
                                refreshBeat: 'failed'
                            }));
                            return () =>
                            {
                                if (refreshBeatAudioRef.current === audio)
                                {
                                    refreshBeatAudioRef.current = null;
                                }
                            };
                        }

                        const markReady = () => setBeatAudioLoadState((current) => (
                        {
                            ...current,
                            refreshBeat: 'ready'
                        }));
                        const markFailed = () => setBeatAudioLoadState((current) => (
                        {
                            ...current,
                            refreshBeat: 'failed'
                        }));
                        const detachLoadListeners = beginPreloadedAudioLoad(audio, markReady, markFailed);

                        return () =>
                        {
                            detachLoadListeners();
                            stopPreloadedAudioElement(audio);
                            if (refreshBeatAudioRef.current === audio)
                            {
                                refreshBeatAudioRef.current = null;
                            }
                        };
                    }, [audioConfig]);

                    useEffect(() =>
                    {
                        const sound = getSoundConfig(audioConfig, 'exitBeat');
                        setBeatAudioLoadState((current) => (
                        {
                            ...current,
                            exitBeat: 'loading'
                        }));
                        const audio = createPreloadedAudioElement(sound);
                        exitBeatAudioRef.current = audio;

                        if (!audio)
                        {
                            setBeatAudioLoadState((current) => (
                            {
                                ...current,
                                exitBeat: 'failed'
                            }));
                            return () =>
                            {
                                if (exitBeatAudioRef.current === audio)
                                {
                                    exitBeatAudioRef.current = null;
                                }
                            };
                        }

                        const markReady = () => setBeatAudioLoadState((current) => (
                        {
                            ...current,
                            exitBeat: 'ready'
                        }));
                        const markFailed = () => setBeatAudioLoadState((current) => (
                        {
                            ...current,
                            exitBeat: 'failed'
                        }));
                        const detachLoadListeners = beginPreloadedAudioLoad(audio, markReady, markFailed);

                        return () =>
                        {
                            detachLoadListeners();
                            stopPreloadedAudioElement(audio);
                            if (exitBeatAudioRef.current === audio)
                            {
                                exitBeatAudioRef.current = null;
                            }
                        };
                    }, [audioConfig]);

                    useEffect(() =>
                    {
                        let cancelled = false;
                        const detachLoadListeners = [];
                        const nextRefs = {};

                        setPreloadedUiAudioLoadState(createAudioLoadState(FRNC_PRELOADED_UI_AUDIO_KEYS, 'loading'));

                        FRNC_PRELOADED_UI_AUDIO_KEYS.forEach((soundKey) =>
                        {
                            const sound = getSoundConfig(audioConfig, soundKey);
                            const audio = createPreloadedAudioElement(sound);
                            nextRefs[soundKey] = audio;

                            if (!audio)
                            {
                                if (!cancelled)
                                {
                                    setPreloadedUiAudioLoadState((current) => (
                                    {
                                        ...current,
                                        [soundKey]: 'failed'
                                    }));
                                }
                                return;
                            }

                            const markReady = () =>
                            {
                                if (cancelled) return;
                                setPreloadedUiAudioLoadState((current) => (
                                {
                                    ...current,
                                    [soundKey]: 'ready'
                                }));
                            };
                            const markFailed = () =>
                            {
                                if (cancelled) return;
                                setPreloadedUiAudioLoadState((current) => (
                                {
                                    ...current,
                                    [soundKey]: 'failed'
                                }));
                            };

                            detachLoadListeners.push(beginPreloadedAudioLoad(audio, markReady, markFailed));
                        });

                        preloadedUiAudioRefs.current = nextRefs;

                        return () =>
                        {
                            cancelled = true;
                            detachLoadListeners.forEach((detach) => detach());
                            Object.values(nextRefs).forEach((audio) => stopPreloadedAudioElement(audio));
                            Object.keys(nextRefs).forEach((soundKey) =>
                            {
                                if (preloadedUiAudioRefs.current[soundKey] === nextRefs[soundKey])
                                {
                                    delete preloadedUiAudioRefs.current[soundKey];
                                }
                            });
                        };
                    }, [audioConfig]);

                    const playManagedUiSound = (soundKey) =>
                    {
                        const audio = preloadedUiAudioRefs.current[soundKey];
                        if (audio)
                        {
                            playPreloadedAudioElement(audio);
                            return;
                        }

                        playConfiguredSound(audioConfigRef.current, soundKey);
                    };

                    useEffect(() =>
                    {
                        if (!showContentUi) return undefined;

                        let cancelled = false;
                        let refreshTimer = null;

                        const setLoadingState = (stage, progress) =>
                        {
                            const nextLabel = getDocLoadLabel(stage);
                            const nextProgress = normalizeDocProgress(typeof progress === 'number' ?
                                progress :
                                FRNC_DOC_LOAD_FALLBACK_PROGRESS[stage]);

                            setDocState((current) =>
                            {
                                if (current.html) return current;
                                if (current.status === 'loading' &&
                                    current.progress === nextProgress &&
                                    current.progressLabel === nextLabel &&
                                    !current.error)
                                {
                                    return current;
                                }

                                return createDocState(
                                {
                                    status: 'loading',
                                    progress: nextProgress,
                                    progressLabel: nextLabel,
                                });
                            });
                        };

                        const loadDocument = async () =>
                        {
                            setLoadingState('preparing');

                            try
                            {
                                setLoadingState('waiting');
                                const response = await fetch(FRNC_DOC_URL,
                                {
                                });
                                const html = await response.text();
                                if (!response.ok) throw new Error(`Document request failed with ${response.status}.`);
                                if (!html.trim()) throw new Error('The document file returned no HTML.');
                                if (cancelled) return;

                                setLoadingState('downloading');
                                setLoadingState('parsing');

                                setDocState((current) =>
                                {
                                    if (current.html === html && current.status === 'ready' && !current.error) return current;
                                    return createDocState(
                                    {
                                        status: 'ready',
                                        html,
                                        progress: FRNC_DOC_LOAD_FALLBACK_PROGRESS.ready,
                                        progressLabel: getDocLoadLabel('ready'),
                                    });
                                });
                            }
                            catch (fetchError)
                            {
                                if (cancelled) return;
                                setDocState((current) =>
                                {
                                    if (current.html)
                                    {
                                        return {
                                            ...current,
                                            progress: 0,
                                            progressLabel: '',
                                            error: fetchError && fetchError.message ?
                                                `${fetchError.message} The Vercel document proxy could not refresh.` :
                                                'Failed to refresh the document through Vercel.',
                                        };
                                    }

                                    return createDocState(
                                    {
                                        status: 'error',
                                        error: fetchError && fetchError.message ?
                                            `${fetchError.message} The Vercel document proxy could not load.` :
                                            'Failed to load the document through Vercel.',
                                    });
                                });
                            }
                            finally
                            {
                                if (!cancelled)
                                {
                                    refreshTimer = setTimeout(loadDocument, FRNC_DOC_REFRESH_MS);
                                }
                            }
                        };

                        loadDocument();
                        return () =>
                        {
                            cancelled = true;
                            if (refreshTimer) clearTimeout(refreshTimer);
                        };
                    }, [showContentUi]);

                    useEffect(() =>
                    {
                        if (docUiIntroState !== 'animating') return undefined;

                        playManagedUiSound('docUiAppears');

                        const finishTimer = setTimeout(() =>
                        {
                            setDocUiIntroState('done');
                        }, FRNC_DOC_UI_INTRO_MS);

                        return () => clearTimeout(finishTimer);
                    }, [docUiIntroState, audioConfig]);

                    useEffect(() =>
                    {
                        if (!showContentUi || docUiIntroState !== 'done')
                        {
                            docMusicAutoplayHandledRef.current = false;
                            return;
                        }

                        if (!docMusicPlaylist.length || docMusicAutoplayHandledRef.current) return;

                        const randomTrackIndex = Math.floor(Math.random() * docMusicPlaylist.length);
                        setDocMusicTrackIndex(randomTrackIndex);
                        setDocMusicPlayerEnabled(true);
                        setDocMusicPlayerPaused(false);
                        docMusicAutoplayHandledRef.current = true;
                    }, [showContentUi, docUiIntroState, docMusicPlaylist]);

                    useEffect(() =>
                    {
                        const currentTrackSrc = getPlaylistTrackSrc(currentDocMusicTrack);
                        let audio = docMusicAudioRef.current;
                        const advanceToNextTrack = () =>
                        {
                            if (!showContentUi || !docMusicPlayerEnabled || !docMusicPlaylist.length) return;
                            setDocMusicTrackIndex((current) => (current + 1) % docMusicPlaylist.length);
                        };

                        if (!currentTrackSrc)
                        {
                            if (audio)
                            {
                                try
                                {
                                    audio.pause();
                                }
                                catch (e)
                                {}
                                try
                                {
                                    audio.onended = null;
                                }
                                catch (e)
                                {}
                                docMusicAudioRef.current = null;
                            }
                            return undefined;
                        }

                        if (!audio || audio.dataset.trackSrc !== currentTrackSrc)
                        {
                            if (audio)
                            {
                                try
                                {
                                    audio.pause();
                                }
                                catch (e)
                                {}
                            }

                            audio = new Audio(currentTrackSrc);
                            audio.dataset.trackSrc = currentTrackSrc;
                            audio.preload = 'auto';
                            audio._baseVolume = typeof currentDocMusicTrack.baseVolume === 'number' ? currentDocMusicTrack.baseVolume : 1.0;
                            try
                            {
                                masterVolume.applyToElement(audio);
                            }
                            catch (e)
                            {}
                            docMusicAudioRef.current = audio;
                        }

                        audio._baseVolume = typeof currentDocMusicTrack.baseVolume === 'number' ? currentDocMusicTrack.baseVolume : 1.0;
                        audio.onended = advanceToNextTrack;

                        if (!showContentUi || !docMusicPlayerEnabled || docMusicPlayerPaused)
                        {
                            try
                            {
                                audio.pause();
                            }
                            catch (e)
                            {}
                            return undefined;
                        }

                        try
                        {
                            masterVolume.applyToElement(audio);
                        }
                        catch (e)
                        {}
                        try
                        {
                            audio.play().catch(() => setDocMusicPlayerPaused(true));
                        }
                        catch (e)
                        {
                            setDocMusicPlayerPaused(true);
                        }

                        return undefined;
                    }, [currentDocMusicTrack, docMusicPlayerEnabled, docMusicPlayerPaused, docMusicPlaylist.length, showContentUi]);

                    useEffect(() =>
                    {
                        if (grantStage !== 'exit-beat-sequence') return;
                        setDocMusicPlayerPaused(true);
                        setDocMusicPlayerEnabled(false);
                    }, [grantStage]);

                    useEffect(() => () =>
                    {
                        const audio = docMusicAudioRef.current;
                        if (!audio) return;
                        try
                        {
                            audio.pause();
                        }
                        catch (e)
                        {}
                        try
                        {
                            audio.onended = null;
                        }
                        catch (e)
                        {}
                        docMusicAudioRef.current = null;
                    }, []);

                    useEffect(() =>
                    {
                        if (grantStage === 'idle') return undefined;

                        if (grantStage === 'await-title-sequence')
                        {
                            if (!isContentStageAudioReady) return undefined;
                            setGrantStage('title-sequence');
                            return undefined;
                        }

                        if (grantStage === 'await-drop')
                        {
                            if (!areAudioKeysReady(preloadedUiAudioLoadState, ['passGoesDown'])) return undefined;

                            const startDropTimer = setTimeout(() =>
                            {
                                playManagedUiSound('passGoesDown');
                                setGrantStage('dropping');
                            }, 500);

                            return () => clearTimeout(startDropTimer);
                        }

                        if (grantStage === 'dropping')
                        {
                            const finishTimer = setTimeout(() =>
                            {
                                // Wait for the 0.45s access panel drop animation to fully clear the screen.
                                setBeatSequenceDisplay(createBeatSequenceDisplay());
                                setBeatSequenceMode(FRNC_SEQUENCE_ENTRY);
                                setGrantStage('beat-sequence');
                            }, 450);

                            return () => clearTimeout(finishTimer);
                        }

                        if (grantStage === 'beat-sequence' || grantStage === 'refresh-beat-sequence' || grantStage === 'exit-beat-sequence')
                        {
                            const sequenceMode = grantStage === 'refresh-beat-sequence' ?
                                FRNC_SEQUENCE_REFRESH :
                                (grantStage === 'exit-beat-sequence' ? FRNC_SEQUENCE_EXIT : beatSequenceMode);
                            const sequenceConfig = getBeatSequenceConfig(sequenceMode);
                            const audioElement = sequenceConfig.audioKey === 'refreshBeat' ?
                                refreshBeatAudioRef.current :
                                (sequenceConfig.audioKey === 'exitBeat' ? exitBeatAudioRef.current : passEntryBeatAudioRef.current);
                            const isBeatAudioReady = sequenceConfig.audioKey === 'refreshBeat' ?
                                isRefreshBeatReady :
                                (sequenceConfig.audioKey === 'exitBeat' ? isExitBeatReady : isPassEntryBeatReady);

                            if (!isBeatAudioReady) return undefined;

                            setBeatSequenceDisplay(createBeatSequenceDisplay());
                            playPreloadedAudioElement(audioElement);

                            const beatTimers = sequenceConfig.sequence.map((step, index) => setTimeout(() =>
                            {
                                setBeatSequenceDisplay((current) => applyBeatSequenceStep(current, step, index + 1, sequenceConfig));
                            }, Math.round(index * FRNC_PASS_ENTRY_BEAT_MS)));

                            const titleSequenceTimer = setTimeout(() =>
                            {
                                if (sequenceConfig.exitRedirect)
                                {
                                    window.location.href = 'https://arielwolf24.com/';
                                    return;
                                }

                                setGrantStage(isContentStageAudioReady ? 'title-sequence' : 'await-title-sequence');
                            }, Math.round((sequenceConfig.totalBeats - 1) * FRNC_PASS_ENTRY_BEAT_MS + FRNC_EXIT_REDIRECT_DELAY_MS));

                            return () =>
                            {
                                beatTimers.forEach((timer) => clearTimeout(timer));
                                clearTimeout(titleSequenceTimer);
                                stopPreloadedAudioElement(audioElement);
                            };
                        }

                        if (grantStage === 'title-sequence')
                        {
                            if (!isContentStageAudioReady) return undefined;

                            playManagedUiSound('titleTransition');

                            const fixedTransitionTimer = setTimeout(() =>
                            {
                                playManagedUiSound('titleTransitionFixed');
                            }, FRNC_TITLE_SEQUENCE_SETTLE_START_MS);

                            const revealTimer = setTimeout(() =>
                            {
                                // The title sequence runs for 1s total; only after that do we reveal and mount the content UI.
                                setShowContentUi(true);
                                setDocUiIntroState('animating');
                                setGrantStage('idle');
                            }, FRNC_TITLE_SEQUENCE_MS);

                            return () =>
                            {
                                clearTimeout(fixedTransitionTimer);
                                clearTimeout(revealTimer);
                            };
                        }

                        return undefined;
                    }, [grantStage, beatSequenceMode, isPassEntryBeatReady, isRefreshBeatReady, isExitBeatReady, isContentStageAudioReady, preloadedUiAudioLoadState]);

                    useEffect(() =>
                    {
                        const pressedCodes = new Set();
                        const resetChordArmedRef = {
                            current: true
                        };

                        const resetAccess = async () =>
                        {
                            await clearServerAccess();
                            setShowContentUi(false);
                            setDocMusicPlayerPaused(true);
                            setDocMusicPlayerEnabled(false);
                            setSteamProfile(null);
                            setError('');
                            setActiveMedia(null);
                            setGrantStage('idle');
                            setBeatSequenceMode(FRNC_SEQUENCE_ENTRY);
                            setBeatSequenceDisplay(createBeatSequenceDisplay());
                            setDocUiIntroState('idle');
                        };

                        const onKeyDown = (event) =>
                        {
                            try
                            {
                                if (!event) return;
                                const isRepeat = !!event.repeat;

                                if (event.code) pressedCodes.add(event.code);

                                const target = event.target;
                                const tag = target && target.tagName ? String(target.tagName).toLowerCase() : '';
                                const isTypingTarget =
                                    tag === 'input' ||
                                    tag === 'textarea' ||
                                    (target && target.isContentEditable);
                                if (isTypingTarget) return;

                                if (!isRepeat && resetChordArmedRef.current && pressedCodes.has('ShiftLeft') && pressedCodes.has('KeyT'))
                                {
                                    resetChordArmedRef.current = false;
                                    resetAccess().catch(() =>
                                    {});
                                }
                            }
                            catch (e)
                            {}
                        };

                        const onKeyUp = (event) =>
                        {
                            try
                            {
                                if (event && event.code) pressedCodes.delete(event.code);
                                if (!pressedCodes.has('ShiftLeft') || !pressedCodes.has('KeyT'))
                                {
                                    resetChordArmedRef.current = true;
                                }
                            }
                            catch (e)
                            {}
                        };

                        window.addEventListener('keydown', onKeyDown);
                        window.addEventListener('keyup', onKeyUp);
                        return () =>
                        {
                            window.removeEventListener('keydown', onKeyDown);
                            window.removeEventListener('keyup', onKeyUp);
                        };
                    }, []);

                    const handleSubmit = async (event) =>
                    {
                        event.preventDefault();
                        if (grantStage !== 'idle') return;

                        try
                        {
                            if (!steamLoginUrl) throw new Error('Steam login is unavailable.');
                            window.location.assign(steamLoginUrl);
                            return;
                        }

                        catch (e)
                        {
                            playConfiguredSound(audioConfig, 'accessDenied');
                            setError(e && e.message ? e.message : 'DENIED: Access denied.');
                        }
                    };

                    useEffect(() =>
                    {
                        if (!activeMedia) return undefined;

                        if (activeMedia.type === 'image')
                        {
                            setImageInspectTransform(
                            {
                                scale: 1,
                                x: 0,
                                y: 0
                            });
                        }

                        const onKeyDown = (event) =>
                        {
                            if (event && event.key === 'Escape') setActiveMedia(null);
                        };

                        window.addEventListener('keydown', onKeyDown);
                        return () => window.removeEventListener('keydown', onKeyDown);
                    }, [activeMedia]);

                    const updateImageInspectScale = (nextScale, anchorX = 0, anchorY = 0) =>
                    {
                        setImageInspectTransform((current) =>
                        {
                            const clampedScale = Math.max(1, Math.min(5, nextScale));
                            if (clampedScale === current.scale)
                            {
                                return current;
                            }

                            const scaleRatio = clampedScale / current.scale;
                            return {
                                scale: clampedScale,
                                x: (current.x - anchorX) * scaleRatio + anchorX,
                                y: (current.y - anchorY) * scaleRatio + anchorY,
                            };
                        });
                    };

                    const resetImageInspectTransform = () =>
                    {
                        setImageInspectTransform(
                        {
                            scale: 1,
                            x: 0,
                            y: 0
                        });
                    };

                    const documentModel = useMemo(() => parseDocumentModel(docState.html), [docState.html]);
                    const docRoot = documentModel.root;
                    const documentMediaKeys = useMemo(() => collectDocumentMediaKeys(docRoot), [docRoot]);
                    const documentSections = useMemo(() => buildDocumentSections(docRoot), [docRoot]);
                    const introContent = useMemo(() =>
                    {
                        if (!documentSections.introNodes.length) return [];
                        return renderDocumentChildren(documentSections.introNodes,
                        {
                            openMedia: setActiveMedia,
                            documentStyles: documentModel.styles,
                            emojiConfig
                        }, 'frnc-doc-intro');
                    }, [documentSections, documentModel.styles, emojiConfig]);
                    const renderedSections = useMemo(() =>
                    {
                        return documentSections.sections.map((section) => (
                        {
                            ...section,
                            renderedContent: renderDocumentChildren(section.contentNodes,
                            {
                                openMedia: setActiveMedia,
                                documentStyles: documentModel.styles,
                                emojiConfig
                            }, `frnc-doc-${section.key}`),
                        }));
                    }, [documentSections, documentModel.styles, emojiConfig, setActiveMedia]);
                    const renderedSectionMap = useMemo(() =>
                    {
                        const map = {};
                        renderedSections.forEach((section) =>
                        {
                            map[section.key] = section;
                        });
                        return map;
                    }, [renderedSections]);
                    const selectedSection = useMemo(() =>
                    {
                        if (!renderedSections.length) return null;
                        if (activeSectionKey && renderedSectionMap[activeSectionKey]) return renderedSectionMap[activeSectionKey];
                        if (activeRootKey && renderedSectionMap[activeRootKey]) return renderedSectionMap[activeRootKey];
                        return renderedSections[0] || null;
                    }, [activeRootKey, activeSectionKey, renderedSectionMap, renderedSections]);
                    const visibleSections = useMemo(() => (selectedSection ? [selectedSection] : []), [selectedSection]);
                    const isGrantingAccess = grantStage !== 'idle';
                    const isShowingAccessGrantedPrompt = grantStage === 'await-drop' || grantStage === 'dropping';
                    const isPreparingPasswordUi = isAccessStatusLoading || (!showContentUi &&
                        grantStage === 'idle' &&
                        !isPasswordStageAudioReady);
                    const canUseDocMusicPlayer = docMusicPlaylist.length > 0 && docMusicPlayerEnabled;
                    const docLoadProgress = normalizeDocProgress(docState.progress);

                    const handleDocMusicPrevious = () =>
                    {
                        if (!docMusicPlaylist.length) return;
                        setDocMusicTrackIndex((current) => (current - 1 + docMusicPlaylist.length) % docMusicPlaylist.length);
                    };

                    const handleDocMusicNext = () =>
                    {
                        if (!docMusicPlaylist.length) return;
                        setDocMusicTrackIndex((current) => (current + 1) % docMusicPlaylist.length);
                    };

                    useEffect(() =>
                    {
                        if (!activeMedia) return;

                        const activeMediaKey = getMediaDescriptorKey(activeMedia);
                        if (!activeMediaKey) return;
                        if (documentMediaKeys.has(activeMediaKey)) return;

                        setActiveMedia(null);
                    }, [activeMedia, documentMediaKeys]);

                    useEffect(() =>
                    {
                        if (!renderedSections.length) return;
                        const nextRootKey = activeRootKey && renderedSections.some((section) => (section.rootKey || section.key) === activeRootKey) ?
                            activeRootKey :
                            (documentSections.mainSections[0] ? documentSections.mainSections[0].key : (renderedSections[0].rootKey || renderedSections[0].key));

                        if (nextRootKey !== activeRootKey) setActiveRootKey(nextRootKey);
                    }, [activeRootKey, documentSections.mainSections, renderedSections]);

                    useEffect(() =>
                    {
                        if (!renderedSections.length) return;

                        const nextSectionKey = activeSectionKey && renderedSectionMap[activeSectionKey] ?
                            activeSectionKey :
                            (activeRootKey || renderedSections[0].key);

                        if (nextSectionKey !== activeSectionKey) setActiveSectionKey(nextSectionKey);
                    }, [activeRootKey, activeSectionKey, renderedSectionMap, renderedSections]);

                    useEffect(() =>
                    {
                        if (!activeRootKey) return;
                        setExpandedSectionKeys((current) => (
                        {
                            ...current,
                            [activeRootKey]: true,
                        }));
                    }, [activeRootKey]);

                    useEffect(() =>
                    {
                        if (!pendingScrollSectionKey) return;
                        const target = sectionRefs.current[pendingScrollSectionKey];
                        if (!target || typeof target.scrollIntoView !== 'function') return;
                        target.scrollIntoView(
                        {
                            behavior: 'smooth',
                            block: 'start'
                        });
                        setPendingScrollSectionKey(null);
                    }, [pendingScrollSectionKey, visibleSections]);

                    const activateSection = (sectionKey) =>
                    {
                        const section = renderedSectionMap[sectionKey];
                        if (!section) return;

                        playManagedUiSound('docButtonClick');
                        const nextRootKey = section.rootKey || section.key;
                        setActiveRootKey(nextRootKey);
                        setActiveSectionKey(section.key);
                        setPendingScrollSectionKey(section.key);
                        setExpandedSectionKeys((current) => (
                        {
                            ...current,
                            ...(section.parentKey ?
                            {
                                [section.parentKey]: true
                            } :
                            {}),
                            ...(section.childKeys && section.childKeys.length ?
                            {
                                [section.key]: true
                            } :
                            {}),
                            [nextRootKey]: true,
                        }));
                    };

                    const toggleSectionExpanded = (section) =>
                    {
                        if (!section.childKeys || section.childKeys.length === 0) return;
                        const nextExpanded = !expandedSectionKeys[section.key];
                        setExpandedSectionKeys((current) => (
                        {
                            ...current,
                            [section.key]: nextExpanded,
                        }));
                        if (!nextExpanded && activeSectionKey && (activeSectionKey === section.key || sectionContainsDescendant(renderedSectionMap, section.key, activeSectionKey)))
                        {
                            setActiveSectionKey(section.key);
                            setActiveRootKey(section.rootKey || section.key);
                            setPendingScrollSectionKey(section.key);
                        }
                    };

                    const renderSectionNavItem = (sectionKey, depth = 0) =>
                    {
                        const section = renderedSectionMap[sectionKey];
                        if (!section) return null;

                        const hasChildren = Boolean(section.childKeys && section.childKeys.length);
                        const isExpanded = hasChildren ? Boolean(expandedSectionKeys[section.key]) : false;
                        const isSelected = section.key === activeSectionKey;
                        const levelIndentPx = depth * 24;

                        return ( <div key = {
                                section.key
                            }
                            style = {
                                {
                                    display: 'grid',
                                    gap: 6,
                                    marginLeft: `${levelIndentPx}px`
                                }
                            } >
                            <div style = {
                                {
                                    borderLeft: depth > 0 ? '1px solid rgba(255,255,255,0.08)' : 'none',
                                    paddingLeft: depth > 0 ? 12 : 0,
                                }
                            } >
                            <button type = "button"
                            onClick = {
                                () => activateSection(section.key)
                            }
                            style = {
                                {
                                    width: '100%',
                                    textAlign: 'left',
                                    padding: section.level === 0 ? '9px 10px' : '8px 10px',
                                    border: '0',
                                    background: isSelected ? 'rgba(255,255,255,0.12)' : 'transparent',
                                    color: isSelected ? '#c9b2ff' : '#f3f3f3',
                                    cursor: 'pointer',
                                    display: 'grid',
                                    gridTemplateColumns: hasChildren ? '26px minmax(0, 1fr)' : '1fr',
                                    alignItems: 'center',
                                    gap: 8,
                                    borderRadius: 6,
                                    transition: 'background 180ms ease, color 180ms ease, transform 180ms ease',
                                    transform: isSelected ? 'translateX(2px)' : 'translateX(0)',
                                    fontSize: depth === 0 ? '0.98rem' : (depth === 1 ? '0.93rem' : '0.88rem'),
                                    fontWeight: depth === 0 ? 500 : 400,
                                    lineHeight: 1.35,
                                    opacity: depth === 0 ? 1 : (depth === 1 ? 0.96 : 0.9),
                                    boxShadow: isSelected ? 'inset 2px 0 0 #8b5cf6' : 'none',
                                }
                            } >
                            {
                                hasChildren ? ( <span onClick = {
                                        (event) =>
                                        {
                                            event.stopPropagation();
                                            toggleSectionExpanded(section);
                                        }
                                    }
                                    style = {
                                        {
                                            width: 26,
                                            height: 26,
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '1.35rem',
                                            lineHeight: 1,
                                            color: 'rgba(255,255,255,0.78)',
                                            transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                            transition: 'transform 180ms ease',
                                            userSelect: 'none',
                                        }
                                    } >
                                    ›
                                    </span>
                                ) : null
                            } <span style = {
                                {
                                    display: 'grid',
                                    gap: 2
                                }
                            } >
                            <span style = {
                                {
                                    fontSize: '0.72em',
                                    letterSpacing: '0.08em',
                                    textTransform: 'uppercase',
                                    opacity: 0.6
                                }
                            } >
                            {
                                section.key
                            } </span> <span >
                            {
                                section.title
                            } </span> </span> </button> </div>
                            {
                                hasChildren ? ( <div style = {
                                        {
                                            display: 'grid',
                                            gridTemplateRows: isExpanded ? '1fr' : '0fr',
                                            transition: 'grid-template-rows 220ms ease, opacity 220ms ease',
                                            opacity: isExpanded ? 1 : 0.72,
                                        }
                                    } >
                                    <div style = {
                                        {
                                            overflow: 'hidden',
                                            display: 'grid',
                                            gap: 6
                                        }
                                    } >
                                    {
                                        section.childKeys.map((childKey) => renderSectionNavItem(childKey, depth + 1))
                                    } </div> </div>
                                ) : null
                            } </div>
                        );
                    };

                    return ( <div style = {
                                shellStyle
                            } >
                            <style >
                            {
                                `
        @keyframes frncPassExitDown {
          0% { transform: translateY(0); }
          55.555% { transform: translateY(-40px); }
          100% { transform: translateY(130vh); }
        }

        /*
          Title sequence timing within the 1s animation:
          0%: starts centered, oversized, and invisible.
          8%: fades fully in while still near the starting position.
          82%: reaches the intended title anchor in the top-left content shell.
          92%: stops overshooting and starts correcting back toward the final anchor.
          100%: settles back onto the exact final title position and stops.
        */
        @keyframes frncBeatPulse {
          0% { transform: scale(0.94) rotate(var(--frnc-beat-tilt-to, 0deg)); opacity: 0.72; }
          35% { transform: scale(1.08) rotate(var(--frnc-beat-tilt-to, 0deg)); opacity: 1; }
          100% { transform: scale(1) rotate(var(--frnc-beat-tilt-to, 0deg)); opacity: 1; }
        }

        @keyframes frncTitleFlyIn {
          0% {
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%) rotate(0deg) scale(2.18);
            opacity: 0;
          }
          8% {
            opacity: 1;
          }
          82% {
            left: 0;
            top: 0;
            transform: translate(0, 0) rotate(-370deg) scale(0.96);
            opacity: 1;
          }
          92% {
            left: 0;
            top: 0;
            transform: translate(-6px, -4px) rotate(-355deg) scale(1);
            opacity: 1;
          }
          100% {
            left: 0;
            top: 0;
            transform: translate(0, 0) rotate(-360deg) scale(1);
            opacity: 1;
          }
        }

        @keyframes frncDocSectionsEnter {
          0% { transform: translateY(72px); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }

        @keyframes frncDocContentEnter {
          0% { transform: translateX(84px); opacity: 0; }
          100% { transform: translateX(0); opacity: 1; }
        }

        @keyframes frncDocNavButtonsEnter {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }

        @keyframes frncDocExitEnter {
          0% { transform: translateY(14px); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }

        @keyframes frncExitSpinUp {
          0% { transform: rotate(0deg); }
          16% { transform: rotate(-18deg); }
          34% { transform: rotate(-96deg); }
          58% { transform: rotate(-336deg); }
          80% { transform: rotate(-720deg); }
          100% { transform: rotate(-1260deg); }
        }
      `
                            } </style>
                            {
                                (grantStage === 'beat-sequence' || grantStage === 'refresh-beat-sequence' || grantStage === 'exit-beat-sequence' || grantStage === 'await-title-sequence' || grantStage === 'title-sequence' || showContentUi) ? ( <div style = {
                                        contentShellStyle
                                    } >
                                    {
                                        grantStage !== 'beat-sequence' && grantStage !== 'refresh-beat-sequence' && grantStage !== 'exit-beat-sequence' && grantStage !== 'await-title-sequence' && ( <div style = {
                                                {
                                                    ...titleAnchorStyle,
                                                    animation: grantStage === 'title-sequence' ? 'frncTitleFlyIn 1s cubic-bezier(0.33, 1, 0.2, 1) forwards' : 'none',
                                                }
                                            } >
                                            {
                                                steamProfile && steamProfile.avatarUrl ? ( <div style = {
                                                        {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 6,
                                                            flex: '0 0 auto',
                                                        }
                                                    } > {
                                                        steamClassIconSource ? ( <img src = {
                                                                steamClassIconSource
                                                            }
                                                            alt = {
                                                                steamClassIconDefinition.label || steamClassIconDefinition.name
                                                            }
                                                            title = {
                                                                steamClassIconDefinition.label || steamClassIconDefinition.name
                                                            }
                                                            style = {
                                                                {
                                                                    width: 30,
                                                                    height: 30,
                                                                    objectFit: 'contain',
                                                                    transform: 'translateX(-4px)',
                                                                }
                                                            }
                                                            /> ) : null
                                                    } <img src = {
                                                        steamProfile.avatarUrl
                                                    }
                                                    alt = ""
                                                    onError = {
                                                        () => setSteamProfile((current) => current ?
                                                        {
                                                            ...current,
                                                            avatarUrl: '',
                                                        } : current)
                                                    }
                                                    style = {
                                                        {
                                                            width: 48,
                                                            height: 48,
                                                            objectFit: 'cover',
                                                            borderRadius: '50%',
                                                            border: '1px solid rgba(255,255,255,0.3)',
                                                        }
                                                    }
                                                    /> </div> ) : null
                                            } <div style = {
                                                {
                                                    display: 'grid',
                                                    gap: 2,
                                                    minWidth: 0,
                                                }
                                            } > <div> POST ÜBER CLARITY PLAYBOOK </div>
                                            {
                                                steamProfile && steamProfile.displayName ? ( <div style = {
                                                        {
                                                            fontSize: '0.72rem',
                                                            lineHeight: 1.2,
                                                            letterSpacing: '0.08em',
                                                            textTransform: 'none',
                                                            opacity: 0.68,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            maxWidth: 'min(52vw, 420px)',
                                                        }
                                                    } >
                                                    {
                                                        steamProfile.displayName
                                                    } </div> ) : null
                                            } </div> </div>
                                        )
                                    }
                                    {
                                        showContentUi && ( <div style = {
                                                {
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 0,
                                                    zIndex: 4,
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    alignItems: 'center',
                                                    minHeight: 34,
                                                    opacity: docUiIntroState === 'done' ? 1 : 0,
                                                    transform: docUiIntroState === 'done' ? 'translateY(0)' : 'translateY(-10px)',
                                                    transition: 'opacity 180ms ease, transform 180ms ease',
                                                    pointerEvents: docUiIntroState === 'done' ? 'auto' : 'none',
                                                }
                                            } >
                                            <div aria-label = "Document music player"
                                            style = {
                                                {
                                                    display: 'grid',
                                                    justifyItems: 'end',
                                                    gap: 4,
                                                    padding: 0,
                                                }
                                            } >
                                            <div style = {
                                                {
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: 6
                                                }
                                            } >
                                            <button type = "button"
                                            aria-label = "Previous track"
                                            onClick = {
                                                handleDocMusicPrevious
                                            }
                                            disabled = {
                                                !canUseDocMusicPlayer
                                            }
                                            style = {
                                                {
                                                    minWidth: 44,
                                                    padding: '6px 8px',
                                                    border: '1px solid rgba(255,255,255,0.2)',
                                                    background: '#111111',
                                                    color: '#ffffff',
                                                    cursor: canUseDocMusicPlayer ? 'pointer' : 'default',
                                                    fontSize: '1rem',
                                                    lineHeight: 1,
                                                    opacity: canUseDocMusicPlayer ? 1 : 0.45,
                                                }
                                            } >
                                            ◀◀
                                            </button> <button type = "button"
                                            aria-label = {
                                                docMusicPlayerPaused ? 'Play track' : 'Pause track'
                                            }
                                            onClick = {
                                                () => setDocMusicPlayerPaused((current) => !current)
                                            }
                                            disabled = {
                                                !canUseDocMusicPlayer
                                            }
                                            style = {
                                                {
                                                    minWidth: 58,
                                                    padding: '6px 8px',
                                                    border: '1px solid rgba(255,255,255,0.28)',
                                                    background: '#151515',
                                                    color: '#ffffff',
                                                    cursor: canUseDocMusicPlayer ? 'pointer' : 'default',
                                                    fontSize: '1rem',
                                                    lineHeight: 1,
                                                    opacity: canUseDocMusicPlayer ? 1 : 0.45,
                                                }
                                            } >
                                            {
                                                docMusicPlayerPaused ? '▶︎' : '⏸'
                                            } </button> <button type = "button"
                                            aria-label = "Next track"
                                            onClick = {
                                                handleDocMusicNext
                                            }
                                            disabled = {
                                                !canUseDocMusicPlayer
                                            }
                                            style = {
                                                {
                                                    minWidth: 44,
                                                    padding: '6px 8px',
                                                    border: '1px solid rgba(255,255,255,0.2)',
                                                    background: '#111111',
                                                    color: '#ffffff',
                                                    cursor: canUseDocMusicPlayer ? 'pointer' : 'default',
                                                    fontSize: '1rem',
                                                    lineHeight: 1,
                                                    opacity: canUseDocMusicPlayer ? 1 : 0.45,
                                                }
                                            } >
                                            ▶︎▶︎
                                            </button> </div> <div style = {
                                                {
                                                    fontSize: '0.68rem',
                                                    lineHeight: 1.2,
                                                    opacity: 0.52,
                                                    letterSpacing: '0.04em',
                                                    whiteSpace: 'nowrap'
                                                }
                                            } >
                                            {
                                                currentDocMusicTrackLabel || 'No track loaded'
                                            } </div> </div> </div>
                                        )
                                    }
                                    {
                                        grantStage === 'await-title-sequence' && ( <div style = {
                                                {
                                                    position: 'absolute',
                                                    inset: 0,
                                                    display: 'grid',
                                                    placeItems: 'center',
                                                    zIndex: 4,
                                                    letterSpacing: '0.12em',
                                                    textTransform: 'uppercase',
                                                    opacity: 0.78,
                                                }
                                            } >
                                            Preparing content audio...
                                            </div>
                                        )
                                    }
                                    {
                                        (grantStage === 'beat-sequence' || grantStage === 'refresh-beat-sequence' || grantStage === 'exit-beat-sequence') && ( <div style = {
                                                {
                                                    position: 'absolute',
                                                    inset: 0,
                                                    display: 'grid',
                                                    placeItems: 'center',
                                                    pointerEvents: 'none',
                                                    zIndex: 4,
                                                }
                                            } >
                                            <div key = {
                                                grantStage === 'exit-beat-sequence' ? 'frnc-exit-sequence' : `frnc-beat-${beatSequenceDisplay.activeBeat}`
                                            }
                                            style = {
                                                {
                                                    ...beginButtonTextStyle,
                                                    '--frnc-beat-tilt-to': `${beatSequenceDisplay.tiltToDeg || 0}deg`,
                                                    display: 'grid',
                                                    gap: '0.16rem',
                                                    justifyItems: 'center',
                                                    textAlign: 'center',
                                                    textTransform: 'uppercase',
                                                    transformOrigin: 'center center',
                                                    transform: grantStage === 'exit-beat-sequence' ?
                                                        `rotate(${beatSequenceDisplay.activeBeat >= FRNC_EXIT_TILT_RESET_BEAT ? (beatSequenceDisplay.tiltToDeg || 0) : 0}deg)` :
                                                        `rotate(${beatSequenceDisplay.tiltToDeg || 0}deg)`,
                                                    animation: grantStage === 'exit-beat-sequence' ?
                                                        (beatSequenceDisplay.activeBeat === FRNC_EXIT_TILT_RESET_BEAT ?
                                                            'frncBeatPulse 180ms ease-out forwards' :
                                                            (beatSequenceDisplay.activeBeat > FRNC_EXIT_TILT_RESET_BEAT ?
                                                                'none' :
                                                                `frncExitSpinUp ${FRNC_EXIT_SPIN_DURATION_MS}ms linear forwards`)) :
                                                        (beatSequenceDisplay.activeBeat > 0 && !getBeatSequenceConfig(grantStage === 'exit-beat-sequence' ? FRNC_SEQUENCE_EXIT : beatSequenceMode).noBounceBeats.has(beatSequenceDisplay.activeBeat) ?
                                                            'frncBeatPulse 180ms ease-out forwards' :
                                                            'none'),
                                                }
                                            } >
                                            <div style = {
                                                {
                                                    minHeight: '1.02em',
                                                    lineHeight: 0.94,
                                                    fontSize: 'clamp(2rem, 5vw, 4.3rem)',
                                                    opacity: beatSequenceDisplay.firstLine ? 1 : 0.18,
                                                }
                                            } >
                                            {
                                                beatSequenceDisplay.firstLine || '\u00a0'
                                            } </div>
                                            {
                                                getBeatSequenceConfig(grantStage === 'exit-beat-sequence' ? FRNC_SEQUENCE_EXIT : beatSequenceMode).useSecondLine && ( <div style = {
                                                        {
                                                            minHeight: '1.02em',
                                                            lineHeight: 0.94,
                                                            fontSize: 'clamp(1.65rem, 4vw, 3.4rem)',
                                                            opacity: beatSequenceDisplay.activeLine === 1 || beatSequenceDisplay.secondLine ? 1 : 0.18,
                                                            color: beatSequenceDisplay.activeLine === 1 ? '#ffffff' : 'rgba(255,255,255,0.8)',
                                                        }
                                                    } >
                                                    {
                                                        beatSequenceDisplay.secondLine || '\u00a0'
                                                    } </div>
                                                )
                                            } </div> </div>
                                        )
                                    } <div style = {
                                        {
                                            ...contentLayoutStyle,
                                            opacity: showContentUi ? 1 : 0,
                                            pointerEvents: showContentUi ? 'auto' : 'none',
                                        }
                                    } >
                                    <div style = {
                                        {
                                            minHeight: 0,
                                            display: 'grid',
                                            gridTemplateColumns: 'minmax(220px, 280px) minmax(0, 1fr)',
                                            gap: 22,
                                            alignItems: 'start',
                                            overflow: 'hidden'
                                        }
                                    } >
                                    <div style = {
                                        {
                                            minHeight: 0,
                                            height: 'clamp(460px, 82vh, 920px)',
                                            paddingTop: 6,
                                            display: 'grid',
                                            gridTemplateRows: 'auto minmax(0, 1fr)',
                                            gap: 8,
                                            alignContent: 'start',
                                            overflow: 'hidden',
                                            opacity: docUiIntroState === 'idle' ? 0 : 1,
                                            transform: docUiIntroState === 'done' ? 'translateY(0)' : 'translateY(72px)',
                                            animation: docUiIntroState === 'animating' ? 'frncDocSectionsEnter 240ms cubic-bezier(0.22, 1, 0.36, 1) both' : 'none',
                                        }
                                    } >
                                    <div style = {
                                        {
                                            fontSize: '0.84rem',
                                            letterSpacing: '0.12em',
                                            textTransform: 'uppercase',
                                            opacity: 0.68,
                                            marginBottom: 4
                                        }
                                    } >
                                    Sections </div>
                                    {
                                        renderedSections.length === 0 && docState.status === 'ready' && ( <div style = {
                                                {
                                                    opacity: 0.7,
                                                    lineHeight: 1.5
                                                }
                                            } >
                                            No numbered sections found. </div>
                                        )
                                    } <div style = {
                                        {
                                            minHeight: 0,
                                            overflowY: 'auto',
                                            paddingRight: 8,
                                            opacity: docUiIntroState === 'done' ? 1 : 0,
                                            animation: docUiIntroState === 'animating' ? 'frncDocNavButtonsEnter 160ms ease both' : 'none',
                                            animationDelay: docUiIntroState === 'animating' ? '400ms' : '0ms',
                                        }
                                    } >
                                    {
                                        documentSections.mainSections.map((section) => renderSectionNavItem(section.key))
                                    } </div> </div> <div style = {
                                        {
                                            minHeight: 0,
                                            opacity: docUiIntroState === 'done' ? 1 : 0,
                                            transform: docUiIntroState === 'done' ? 'translateX(0)' : 'translateX(84px)',
                                            animation: docUiIntroState === 'animating' ? 'frncDocContentEnter 240ms cubic-bezier(0.22, 1, 0.36, 1) both' : 'none',
                                            animationDelay: docUiIntroState === 'animating' ? '250ms' : '0ms',
                                        }
                                    } >
                                    <div style = {
                                        {
                                            height: 'clamp(460px, 82vh, 920px)',
                                            border: '1px solid rgba(255,255,255,0.18)',
                                            background: '#0d0d0d',
                                            boxShadow: '0 18px 48px rgba(0,0,0,0.35)',
                                            overflow: 'hidden',
                                        }
                                    } >
                                    <div style = {
                                        {
                                            height: '100%',
                                            overflowY: 'auto',
                                            overflowX: 'hidden',
                                            minWidth: 0,
                                            paddingTop: 'clamp(18px, 2.5vw, 34px)',
                                            paddingRight: 'clamp(18px, 2.5vw, 34px)',
                                            paddingLeft: 'clamp(18px, 2.5vw, 34px)',
                                            paddingBottom: 'clamp(44px, 7vh, 84px)',
                                            boxSizing: 'border-box',
                                            fontSize: 'clamp(0.98rem, 1.15vw, 1.08rem)',
                                            fontFamily: FRNC_CONTENT_FONT_STACK,
                                            overflowWrap: 'anywhere',
                                            wordBreak: 'break-word',
                                        }
                                    } >
                                    {
                                        docState.status === 'loading' && ( <div style = {
                                                {
                                                    minHeight: '100%',
                                                    display: 'grid',
                                                    placeItems: 'center',
                                                }
                                            } >
                                            <div style = {
                                                {
                                                    display: 'grid',
                                                    gap: 10,
                                                    width: 'min(100%, 440px)',
                                                    textAlign: 'center'
                                                }
                                            } >
                                            <div style = {
                                                {
                                                    display: 'flex',
                                                    alignItems: 'baseline',
                                                    justifyContent: 'space-between',
                                                    gap: 16
                                                }
                                            } >
                                            <div style = {
                                                {
                                                    fontSize: '0.76rem',
                                                    letterSpacing: '0.12em',
                                                    textTransform: 'uppercase',
                                                    opacity: 0.58
                                                }
                                            } >
                                            Loading </div> <div style = {
                                                {
                                                    fontSize: '1rem',
                                                    fontVariantNumeric: 'tabular-nums',
                                                    opacity: 0.84
                                                }
                                            } >
                                            {
                                                docLoadProgress
                                            } %
                                            </div> </div> <div style = {
                                                {
                                                    height: 8,
                                                    border: '1px solid rgba(255,255,255,0.12)',
                                                    background: 'rgba(255,255,255,0.05)',
                                                    overflow: 'hidden'
                                                }
                                            } >
                                            <div style = {
                                                {
                                                    width: `${docLoadProgress}%`,
                                                    height: '100%',
                                                    background: 'linear-gradient(90deg, rgba(255,255,255,0.3), rgba(255,255,255,0.85))',
                                                    transition: 'width 180ms ease',
                                                }
                                            }
                                            /> </div> <div style = {
                                                {
                                                    opacity: 0.78,
                                                    lineHeight: 1.6
                                                }
                                            } >
                                            {
                                                docState.progressLabel || 'Loading document...'
                                            } </div> <div style = {
                                                {
                                                    opacity: 0.58,
                                                    lineHeight: 1.55,
                                                    fontSize: '0.92rem'
                                                }
                                            } >
                                            This document may take a
                                            moment to load from the local site file. </div> </div> </div>
                                        )
                                    }
                                    {
                                        docState.status === 'config-missing' && <div style = {
                                            {
                                                color: '#ffd4a3',
                                                lineHeight: 1.6
                                            }
                                        } >
                                        {
                                            docState.error
                                        } </div>}
                                        {
                                            docState.status === 'error' && <div style = {
                                                {
                                                    color: '#ffb1b1',
                                                    lineHeight: 1.6
                                                }
                                            } >
                                            {
                                                docState.error
                                            } </div>}
                                            {
                                                docState.status === 'ready' && visibleSections.length === 0 && introContent.length > 0 && introContent
                                            }
                                            {
                                                docState.status === 'ready' && introContent.length === 0 && renderedSections.length === 0 && <div style = {
                                                        {
                                                            opacity: 0.78
                                                        }
                                                    } > The document loaded, but no readable content was found. </div>}
                                                    {
                                                        docState.status === 'ready' && visibleSections.map((section) => ( <section key = {
                                                                        section.key
                                                                    }
                                                                    ref = {
                                                                        (element) =>
                                                                        {
                                                                            if (element) sectionRefs.current[section.key] = element;
                                                                        }
                                                                    }
                                                                    style = {
                                                                        {
                                                                            marginBottom: '2rem',
                                                                            scrollMarginTop: 18
                                                                        }
                                                                    } >
                                                                    <div style = {
                                                                        {
                                                                            marginBottom: '0.9rem',
                                                                            paddingBottom: '0.55rem',
                                                                            borderBottom: '1px solid rgba(255,255,255,0.12)'
                                                                        }
                                                                    } >
                                                                    <div style = {
                                                                        {
                                                                            fontSize: '0.76rem',
                                                                            letterSpacing: '0.12em',
                                                                            textTransform: 'uppercase',
                                                                            opacity: 0.58
                                                                        }
                                                                    } >
                                                                    {
                                                                        section.key
                                                                    } </div> <div style = {
                                                                        {
                                                                            fontSize: section.level === 0 ? '1.6rem' : (section.level === 1 ? '1.28rem' : '1.1rem'),
                                                                            lineHeight: 1.25,
                                                                            marginTop: 4
                                                                        }
                                                                    } >
                                                                    {
                                                                        section.title
                                                                    } </div> </div>
                                                                    {
                                                                        section.renderedContent.length === 0 ? <div style = {
                                                                                {
                                                                                    opacity: 0.66
                                                                                }
                                                                            } > This section is empty. </div> : section.renderedContent} </section>
                                                                    ))
                                                            } </div> </div> </div> </div> <button
                                                        type = "button"
                                                        onClick = {
                                                            () =>
                                                            {
                                                                if (grantStage !== 'idle') return;
                                                                setDocMusicPlayerPaused(true);
                                                                setDocMusicPlayerEnabled(false);
                                                                setShowContentUi(false);
                                                                setDocUiIntroState('idle');
                                                                setBeatSequenceMode(FRNC_SEQUENCE_EXIT);
                                                                setBeatSequenceDisplay(createBeatSequenceDisplay());
                                                                setGrantStage('exit-beat-sequence');
                                                            }
                                                        }
                                                        style = {
                                                                {
                                                                    position: 'absolute',
                                                                    right: 0,
                                                                    bottom: 0,
                                                                    zIndex: 5,
                                                                    padding: '10px 18px',
                                                                    border: '1px solid rgba(255,255,255,0.28)',
                                                                    background: '#111111',
                                                                    color: '#ffffff',
                                                                    letterSpacing: '0.1em',
                                                                    textTransform: 'uppercase',
                                                                    cursor: 'pointer',
                                                                    opacity: docUiIntroState === 'done' ? 1 : 0,
                                                                    transform: docUiIntroState === 'done' ? 'translateY(0)' : 'translateY(14px)',
                                                                    animation: docUiIntroState === 'animating' ? 'frncDocExitEnter 160ms ease both' : 'none',
                                                                    animationDelay: docUiIntroState === 'animating' ? '600ms' : '0ms',
                                                                }
                                                            } >
                                                            Exit </button> </div> </div>
                                                    ): grantStage !== 'title-sequence' ? (
                                                        isPreparingPasswordUi ? ( <div style = {
                                                                {
                                                                    width: 'min(92vw, 440px)',
                                                                    display: 'grid',
                                                                    gap: 12,
                                                                    justifyItems: 'center',
                                                                    textAlign: 'center',
                                                                }
                                                            } >
                                                            <div style = {
                                                                {
                                                                    fontSize: 'clamp(1.35rem, 3vw, 2rem)'
                                                                }
                                                            } >
                                                            Setting up with server...
                                                            </div> <div style = {
                                                                {
                                                                    opacity: 0.72,
                                                                    lineHeight: 1.5
                                                                }
                                                            } >
                                                            Loading shit before the secure prompt opens. </div> </div>
                                                        ) : ( <form onSubmit = {
                                                                    handleSubmit
                                                                }
                                                                style = {
                                                                    {
                                                                        width: 'min(92vw, 620px)',
                                                                        alignSelf: 'center',
                                                                        margin: '0 auto',
                                                                        display: 'grid',
                                                                        gap: 16,
                                                                        justifyItems: 'center',
                                                                        pointerEvents: isGrantingAccess ? 'none' : 'auto',
                                                                        animation: grantStage === 'dropping' ? 'frncPassExitDown 0.45s linear forwards' : 'none',
                                                                        willChange: grantStage === 'dropping' ? 'transform' : 'auto',
                                                                    }
                                                                } >
                                                                <div style = {
                                                                    {
                                                                        ...beginButtonTextStyle,
                                                                        width: '100%',
                                                                        fontSize: 'clamp(1.35rem, 3vw, 2rem)',
                                                                        textAlign: 'center',
                                                                        whiteSpace: 'normal',
                                                                        boxSizing: 'border-box',
                                                                        color: isShowingAccessGrantedPrompt ? '#6dff8f' : beginButtonTextStyle.color,
                                                                    }
                                                                } >
                                                                {
                                                                    isShowingAccessGrantedPrompt ? 'Access granted' : 'Are you part of team Post Über Clarity?'
                                                                } </div> <div style = {
                                                                    {
                                                                        width: '100%',
                                                                        color: 'rgba(255,255,255,0.78)',
                                                                        textAlign: 'center',
                                                                        lineHeight: 1.5,
                                                                        boxSizing: 'border-box',
                                                                    }
                                                                } > Sign in with Steam to verify you aren't a spy. </div>
                                                                <div style = {
                                                                    {
                                                                        width: '100%',
                                                                        color: 'rgb(204, 0, 0)',
                                                                        textAlign: 'center',
                                                                        lineHeight: 1.5,
                                                                        boxSizing: 'border-box',
                                                                    }
                                                                } > Please note that we only check your steam profile to validate your identity and check our team records that you are a Main player in our team. Under no circumstances will we ever access your personal information, otherwise VALVe will send their agents to blow my brains out at the back of a dark alley. </div>

                                                                
                                                                <button type = "submit"
                                                                disabled = {
                                                                    isGrantingAccess || !steamLoginUrl
                                                                }
                                                                style = {
                                                                    {
                                                                        padding: '10px 22px',
                                                                        border: '1px solid rgba(255,255,255,0.28)',
                                                                        borderRadius: 0,
                                                                        background: '#151515',
                                                                        color: '#fff',
                                                                        cursor: isGrantingAccess || !steamLoginUrl ? 'default' : 'pointer',
                                                                        fontSize: '0.98rem',
                                                                        opacity: isGrantingAccess || !steamLoginUrl ? 0.72 : 1,
                                                                    }
                                                                } > Sign in with Steam </button>
                                                                {
                                                                    error ? <div style = {
                                                                            {
                                                                                color: '#ff9d9d',
                                                                                fontSize: '0.95rem'
                                                                            }
                                                                        } >
                                                                        {
                                                                            error
                                                                        } </div> : null} </form>
                                                                )
                                                        ): null
                                                    }
                                                    {
                                                        activeMedia && ( <div onClick = {
                                                                () => setActiveMedia(null)
                                                            }
                                                            style = {
                                                                {
                                                                    position: 'fixed',
                                                                    inset: 0,
                                                                    zIndex: 24000,
                                                                    background: 'rgba(0,0,0,0.42)',
                                                                    backdropFilter: 'blur(10px)',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    padding: '4vh 4vw'
                                                                }
                                                            } >
                                                            <div onClick = {
                                                                (event) => event.stopPropagation()
                                                            }
                                                            style = {
                                                                {
                                                                    width: 'min(92vw, 1380px)',
                                                                    maxHeight: '92vh',
                                                                    background: 'rgba(8,8,8,0.92)',
                                                                    border: '1px solid rgba(255,255,255,0.18)',
                                                                    boxShadow: '0 28px 80px rgba(0,0,0,0.55)',
                                                                    padding: 18,
                                                                    display: 'grid',
                                                                    gap: 14
                                                                }
                                                            } >
                                                            <div style = {
                                                                {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    gap: 12
                                                                }
                                                            } >
                                                            <div style = {
                                                                {
                                                                    opacity: 0.82,
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap'
                                                                }
                                                            } >
                                                            {
                                                                activeMedia.title || activeMedia.alt || 'Media preview'
                                                            } </div> <button type = "button"
                                                            onClick = {
                                                                () => setActiveMedia(null)
                                                            }
                                                            style = {
                                                                {
                                                                    padding: '0.55rem 0.95rem',
                                                                    border: '1px solid rgba(255,255,255,0.22)',
                                                                    background: 'rgba(255,255,255,0.04)',
                                                                    color: '#fff',
                                                                    cursor: 'pointer'
                                                                }
                                                            } >
                                                            Close </button> </div>
                                                            {
                                                                activeMedia.type === 'image' && ( <div style = {
                                                                        {
                                                                            display: 'flex',
                                                                            justifyContent: 'flex-end',
                                                                            gap: 10
                                                                        }
                                                                    } >
                                                                    <button type = "button"
                                                                    onClick = {
                                                                        () => updateImageInspectScale(imageInspectTransform.scale / 1.2)
                                                                    }
                                                                    style = {
                                                                        {
                                                                            padding: '0.45rem 0.8rem',
                                                                            border: '1px solid rgba(255,255,255,0.22)',
                                                                            background: 'rgba(255,255,255,0.04)',
                                                                            color: '#fff',
                                                                            cursor: 'pointer'
                                                                        }
                                                                    } >
                                                                    -
                                                                    </button> <button type = "button"
                                                                    onClick = {
                                                                        resetImageInspectTransform
                                                                    }
                                                                    style = {
                                                                        {
                                                                            padding: '0.45rem 0.8rem',
                                                                            border: '1px solid rgba(255,255,255,0.22)',
                                                                            background: 'rgba(255,255,255,0.04)',
                                                                            color: '#fff',
                                                                            cursor: 'pointer'
                                                                        }
                                                                    } >
                                                                    Reset </button> <button type = "button"
                                                                    onClick = {
                                                                        () => updateImageInspectScale(imageInspectTransform.scale * 1.2)
                                                                    }
                                                                    style = {
                                                                        {
                                                                            padding: '0.45rem 0.8rem',
                                                                            border: '1px solid rgba(255,255,255,0.22)',
                                                                            background: 'rgba(255,255,255,0.04)',
                                                                            color: '#fff',
                                                                            cursor: 'pointer'
                                                                        }
                                                                    } >
                                                                    +
                                                                    </button> </div>
                                                                )
                                                            } <div onWheel = {
                                                                (event) =>
                                                                {
                                                                    if (!activeMedia || activeMedia.type !== 'image') return;
                                                                    event.preventDefault();
                                                                    const rect = event.currentTarget.getBoundingClientRect();
                                                                    const anchorX = event.clientX - rect.left - rect.width / 2;
                                                                    const anchorY = event.clientY - rect.top - rect.height / 2;
                                                                    const scaleDelta = event.deltaY < 0 ? 1.12 : (1 / 1.12);
                                                                    updateImageInspectScale(imageInspectTransform.scale * scaleDelta, anchorX, anchorY);
                                                                }
                                                            }
                                                            style = {
                                                                {
                                                                    minHeight: 0,
                                                                    overflow: 'auto',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    cursor: activeMedia.type === 'image' && imageInspectTransform.scale > 1 ? 'grab' : 'default'
                                                                }
                                                            } >
                                                            {
                                                                activeMedia.type === 'image' && ( <img src = {
                                                                        activeMedia.src
                                                                    }
                                                                    alt = {
                                                                        activeMedia.alt || 'Expanded document image'
                                                                    }
                                                                    draggable = {
                                                                        false
                                                                    }
                                                                    onDragStart = {
                                                                        (event) => event.preventDefault()
                                                                    }
                                                                    onPointerDown = {
                                                                        (event) =>
                                                                        {
                                                                            if (imageInspectTransform.scale <= 1) return;
                                                                            imageInspectDragRef.current = {
                                                                                pointerId: event.pointerId,
                                                                                startX: event.clientX,
                                                                                startY: event.clientY,
                                                                                originX: imageInspectTransform.x,
                                                                                originY: imageInspectTransform.y,
                                                                            };
                                                                            try
                                                                            {
                                                                                event.currentTarget.setPointerCapture(event.pointerId);
                                                                            }
                                                                            catch (e)
                                                                            {}
                                                                        }
                                                                    }
                                                                    onPointerMove = {
                                                                        (event) =>
                                                                        {
                                                                            const dragState = imageInspectDragRef.current;
                                                                            if (!dragState || dragState.pointerId !== event.pointerId) return;
                                                                            setImageInspectTransform((current) => (
                                                                            {
                                                                                ...current,
                                                                                x: dragState.originX + (event.clientX - dragState.startX),
                                                                                y: dragState.originY + (event.clientY - dragState.startY),
                                                                            }));
                                                                        }
                                                                    }
                                                                    onPointerUp = {
                                                                        (event) =>
                                                                        {
                                                                            if (imageInspectDragRef.current.pointerId !== event.pointerId) return;
                                                                            imageInspectDragRef.current = {
                                                                                pointerId: null,
                                                                                startX: 0,
                                                                                startY: 0,
                                                                                originX: 0,
                                                                                originY: 0
                                                                            };
                                                                            try
                                                                            {
                                                                                event.currentTarget.releasePointerCapture(event.pointerId);
                                                                            }
                                                                            catch (e)
                                                                            {}
                                                                        }
                                                                    }
                                                                    onPointerCancel = {
                                                                        (event) =>
                                                                        {
                                                                            if (imageInspectDragRef.current.pointerId !== event.pointerId) return;
                                                                            imageInspectDragRef.current = {
                                                                                pointerId: null,
                                                                                startX: 0,
                                                                                startY: 0,
                                                                                originX: 0,
                                                                                originY: 0
                                                                            };
                                                                            try
                                                                            {
                                                                                event.currentTarget.releasePointerCapture(event.pointerId);
                                                                            }
                                                                            catch (e)
                                                                            {}
                                                                        }
                                                                    }
                                                                    style = {
                                                                        {
                                                                            display: 'block',
                                                                            maxWidth: '100%',
                                                                            maxHeight: '78vh',
                                                                            objectFit: 'contain',
                                                                            transform: `translate(${imageInspectTransform.x}px, ${imageInspectTransform.y}px) scale(${imageInspectTransform.scale})`,
                                                                            transformOrigin: 'center center',
                                                                            userSelect: 'none',
                                                                            touchAction: 'none',
                                                                            cursor: imageInspectTransform.scale > 1 ? 'grab' : 'zoom-in',
                                                                        }
                                                                    }
                                                                    />
                                                                )
                                                            }
                                                            {
                                                                activeMedia.type === 'video' && ( <video controls autoPlay preload = "metadata"
                                                                    style = {
                                                                        {
                                                                            display: 'block',
                                                                            width: '100%',
                                                                            maxWidth: '100%',
                                                                            maxHeight: '78vh',
                                                                            background: '#000'
                                                                        }
                                                                    } >
                                                                    <source src = {
                                                                        activeMedia.src
                                                                    }
                                                                    /> </video>
                                                                )
                                                            }
                                                            {
                                                                activeMedia.type === 'embed' && ( <div style = {
                                                                        {
                                                                            width: 'min(88vw, 1240px)',
                                                                            aspectRatio: '16 / 9',
                                                                            background: '#000'
                                                                        }
                                                                    } >
                                                                    <iframe src = {
                                                                        activeMedia.src
                                                                    }
                                                                    title = {
                                                                        activeMedia.title || 'Embedded media'
                                                                    }
                                                                    style = {
                                                                        {
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            border: 0
                                                                        }
                                                                    }
                                                                    allow = "autoplay; encrypted-media; picture-in-picture; fullscreen"
                                                                    allowFullScreen />
                                                                    </div>
                                                                )
                                                            } </div> </div> </div>
                                                        )
                                                    } </div>
                                            );
                                        }
